<template>
  <v-container fluid class="pa-0" v-bind:class="{'pb-2 px-0 pt-0': stackedView,'pa-0':!stackedView}">
    <v-row class="justify-space-between">
      <v-col cols="12" sm="12" :md="stackedView ? 12 : 4" :order="stackedView ? 2 : 1"
      v-bind:class="{'px-4 py-0':stackedView,'px-0 pl-3 pt-2 pb-1 pb-sm-3':!stackedView,'pr-4':$vuetify.breakpoint.mdAndDown}"
      >
        <MediaModeForm v-if="(currentUser.clientType === 'Media' || currentUser.clientType === 'Driblab') && !stackedView" :fields="mediaModeFields"
        :mediaMode="mediaMode" @mediaModeChange="onMediaModeChange($event)"
        :mediaModeData="mediaModeData" @mediaModeDataChange="onMediaModeDataChange($event)"
        :mediaModeFlags="mediaModeFlags" @mediaModeFlagsChange="mediaModeFlags = $event" selectorMode></MediaModeForm>
        <v-card class="mx-auto pa-1" elevation="0" outlined>
          <v-card-actions class="d-flex flex-column">
            <v-row id="player-season-selector" class="w-100">
              <v-col cols="12" class="pa-0 py-2">
                <v-card-title class="pa-0 mb-0 header-font" style="font-size: 22px;">{{ $t('general.filters') }}</v-card-title>
              </v-col>
              <v-col cols="12" sm="12" class="px-0 pt-1" v-if="playerSeasonsPlayed && playerSeasonsPlayed.length >= 8">
                 <div
                  class="mr-5 pt-0 mt-0 primary--text font-weight-bold body-1"
                >
                  {{ $t('app.seasonStats') }}
                  <v-skeleton-loader v-if="loading" type="text" class="mt-2"></v-skeleton-loader>
                </div>
                <v-autocomplete clearable v-if="showSeasonsAsCheckbox && !loading" :items="playerSeasonDataFiltered" v-model="seasonDataSelectedCheckBoxModel" class="w-100"
                multiple hide-details dense item-value="compoundId" item-text="compoundText"
                  @change="onAutoCompleteSeasonChange($event)">
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text" v-if="index <= 2">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="font-weight-bold">{{item.seasonName}}</span>
                      <span class="mx-1">@</span>
                      <span class="font-weight-medium">{{item.teamName}}</span>
                    </v-chip>
                    <span
                      v-if="index === 3"
                      class="primary--text body-2 subheader-font"
                    >(+{{ seasonDataSelectedCheckBoxModel.length - 3 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <v-card-text
                      class="px-0 py-1 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center">
                      <div>
                        <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                          <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                        </object>
                        <span>{{item.seasonName}}</span>
                      </div>
                      <span class="body-2 subheader-font">
                        {{item.teamName}} 
                        <span v-if="item.minutesPlayed" class="ms-1">{{ `(${item.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                      </span>
                    </v-card-text>
                  </template>
                </v-autocomplete>
                <v-autocomplete clearable v-if="!showSeasonsAsCheckbox" :items="playerSeasonDataFiltered" v-model="seasonDataSelectedRadiosModel" hide-details
                  dense item-value="compoundId" item-text="compoundText"
                  @change="onAutoCompleteSeasonChange($event)">
                  <template v-slot:selection="{item}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="font-weight-bold">{{item.seasonName}}</span>
                      <span class="mx-1">@</span>
                      <span class="font-weight-medium">{{item.teamName}}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{item}">
                    <v-card-text
                      class="px-0 py-1 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center">
                      <div>
                        <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                          <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                        </object>
                        <span>{{item.seasonName}}</span>
                      </div>
                      <span class="body-2 subheader-font">
                        {{item.teamName}} 
                        <span v-if="item.minutesPlayed" class="ms-1">{{ `(${item.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                      </span>
                    </v-card-text>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="d-flex py-0 align-start pr-0" cols="12" v-if="playerSeasonsPlayed &&  playerSeasonsPlayed.length < 8">
                <v-row>
                  <v-col
                    v-if="showSeasonsAsCheckbox"
                    class="d-flex py-0 pr-1"
                    cols="12"
                    sm="12"
                    v-for="(seasonData, index) in playerSeasonDataCurrentYear"
                    :key="index"
                  >
                    <v-checkbox
                      :key="index"
                      :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                      v-model="seasonDataSelectedCheckBoxModel"
                      class="px-2 mt-0 py-1"
                      color="secondary"
                      hide-details
                      @change="onSeasonChange(seasonData)"
                      :disabled="seasonData.disabled"
                    > 
                      <template v-slot:label>
                        <v-card-text
                          class="pa-0 primary--text body-1 font-weight-medium d-flex flex-column align-start justify-center">
                          <div>
                            <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                              <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                            </object>
                            <span>{{seasonData.seasonName}}</span>
                          </div>
                          <span class="body-2 subheader-font">
                            {{seasonData.teamName}} 
                            <span v-if="seasonData.minutesPlayed" class="ms-1">{{ `(${seasonData.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                          </span>
                        </v-card-text>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col
                    v-if="!showSeasonsAsCheckbox"
                    class="d-flex py-0 pr-1"
                    cols="12"
                    sm="12"
                    v-for="(seasonData, index) in playerSeasonDataCurrentYear"
                    :key="index"
                  >
                    <v-radio-group
                      @change="onSeasonChange(seasonData)"
                      :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                      v-model="seasonDataSelectedRadiosModel"
                      row
                      dense
                      hide-details
                      class="mt-0 d-flex flex-column"
                    >
                      <v-radio
                        :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                        :key="index"
                        class="px-2 mt-0"
                        color="secondary"
                        :disabled="seasonData.disabled"
                      > 
                        <template v-slot:label>
                          <v-card-text
                            class="pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center">
                            <div>
                              <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                                <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                              </object>
                              <span>{{seasonData.seasonName}}</span>
                            </div>
                            <span class="body-2 subheader-font">
                              {{seasonData.teamName}} 
                              <span v-if="seasonData.minutesPlayed" class="ms-1">{{ `(${seasonData.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                            </span>
                          </v-card-text>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="d-flex py-0 align-start" cols="12" v-if="playerSeasonsPlayed && playerSeasonsPlayed.length < 8">
                <v-row v-if="playerSeasonDataLastYear">
                  <v-col
                    v-if="showSeasonsAsCheckbox"
                    class="d-flex py-0 pr-1"
                    cols="12"
                    sm="12"
                    v-for="(seasonData, index) in playerSeasonDataLastYear"
                    :key="index"
                  >
                    <v-checkbox
                      :key="index"
                      :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                      v-model="seasonDataSelectedCheckBoxModel"
                      hide-details
                      class="px-2 mt-0 py-1"
                      color="secondary"
                      @change="onSeasonChange(seasonData)"
                      :disabled="seasonData.disabled"
                    > 
                      <template v-slot:label>
                        <v-card-text
                          class="pa-0 primary--text body-1 font-weight-medium d-flex flex-column align-start justify-center">
                          <div>
                            <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                              <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                            </object>
                            <span>{{seasonData.seasonName}}</span>
                          </div>
                          <span class="body-2 subheader-font">
                            {{seasonData.teamName}} 
                            <span v-if="seasonData.minutesPlayed" class="ms-1">{{ `(${seasonData.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                          </span>
                        </v-card-text>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col
                    v-if="!showSeasonsAsCheckbox"
                    class="d-flex py-0 pr-1"
                    cols="12"
                    sm="12"
                    v-for="(seasonData, index) in playerSeasonDataLastYear"
                    :key="index"
                  >
                    <v-radio-group
                      @change="onSeasonChange(seasonData)"
                      :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                      v-model="seasonDataSelectedRadiosModel"
                      row
                      dense
                      hide-details
                      class="mt-0 py-0 d-flex flex-column"
                    >
                      <v-radio
                        :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                        :key="index"
                        class="px-2 mt-0 py-1"
                        color="secondary"
                        :disabled="seasonData.disabled"
                      > 
                        <template v-slot:label>
                          <v-card-text
                            class="pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center">
                            <div>
                              <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                                <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                              </object>
                              <span>{{seasonData.seasonName}}</span>
                            </div>
                            <span class="body-2 subheader-font">
                              {{seasonData.teamName}} 
                              <span v-if="seasonData.minutesPlayed" class="ms-1">{{ `(${seasonData.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                            </span>
                          </v-card-text>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="w-100">
              <v-col cols="12" sm="12" class="pt-0 pb-1 px-0" id="filter-radar-games">
                <div
                  class="mr-5 pt-2 primary--text font-weight-bold body-1"
                >
                  {{ $t("general.games") }}
                  <v-skeleton-loader v-if="loading" type="paragraph,text" class="mt-2"></v-skeleton-loader>
                  <v-tooltip top color="lightSecondary lighten-4" max-width="300" v-if="seasonsWithout60MinsGames && !loading">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ms-1" x-small color="secondary" v-on="on" v-bind="attrs">info</v-icon>
                    </template>
                    <span class="black--text body-1">{{ $t('disabledTooltips.seasonsWithout60MinsGames') }}</span>
                  </v-tooltip>
                </div>
                <v-radio-group
                  v-if="!loading"
                  @change="onRadarGamesChange()"
                  v-model="allGamesModel"
                  row
                  dense
                  hide-details
                  :disabled="seasonsWithout60MinsGames"
                  class="pl-2 mt-0"
                >
                  <v-radio
                    :value="true"
                    color="secondary"
                    :label="$t('general.all')"
                  >
                    <template v-slot:label>
                      <span class="body-1 primary--text font-weight-medium">
                        {{$t('general.all')}}
                      </span>
                    </template>
                  </v-radio>
                  <v-radio
                    :value="false"
                    color="secondary"
                    label="+60 mins."
                  >
                    <template v-slot:label>
                      <span class="body-1 primary--text font-weight-medium">
                        +60 mins.
                      </span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" class="pt-0 pb-1" id="player-radar-selector">
                <div
                  class="mr-5 pt-2 primary--text font-weight-bold body-1"
                >
                  Radar {{ $t("playerRecruitment.template") }}
                  <v-btn small @click="onNewTemplateClick()" rounded class="elevation-0 monospace-font white--text px-2" color="secondary">
                    <v-icon color="white" small>add</v-icon>{{$t("general.new")}}
                  </v-btn>
                  <v-skeleton-loader v-if="loading" type="paragraph,text" class="mt-2"></v-skeleton-loader>
                </div>
                <v-radio-group
                  v-if="!loading"
                  @change="onTemplateChange()"
                  v-model="templateActiveId"
                  dense
                  hide-details
                  class="pl-2 mt-0 d-flex flex-column"
                >
                  <div
                    v-for="(group, groupKey) in groupedTemplates"
                    :key="groupKey"
                    class="mb-4"
                  >
                    <div class="mb-2 primary--text font-weight-bold subheader-font body-1">
                      <v-icon class="me-1" :style="`font-size: ${getRadarTemplateSubtitle(groupKey).size}`">
                        {{ getRadarTemplateSubtitle(groupKey).icon }}
                      </v-icon>
                      {{ getRadarTemplateSubtitle(groupKey).label }}
                    </div>
                    <v-row dense no-gutters wrap class="d-flex flex-row">
                      <v-col
                        v-for="template in group"
                        :key="template.radarId"
                        cols="auto"
                      >
                        <v-radio class="me-2 custom-radio"
                          :value="template.radarId"
                          color="secondary"
                          :disabled="(physicalRadarDisabled && template.cPD) || (arrigoRadarDisabled && template.cA)"
                          :style="getRadioStyle(template)"
                        >
                          <template v-slot:label>
                            <span class="body-1 primary--text font-weight-medium">
                              {{ template.radarName }}
                            </span>
                            <span class="ml-1 body-2" v-if="hasCustomRadars && template.clientId === 0">(Driblab)</span>
                          </template>
                        </v-radio>
                      </v-col>
                    </v-row>
                  </div>
                </v-radio-group>
              </v-col>
              <v-col v-if="templateActive && !templateActive.cPD" cols="12" sm="12" class="pt-0 pb-1" id="player-position-selector">
                <div class="d-flex flex-column">
                  <div
                    class="mr-5 pt-2 primary--text font-weight-bold body-1"
                  >
                    {{ $t("playerRecruitment.positionsPlayed") }}
                    <v-skeleton-loader v-if="loading" type="text" class="mt-2"></v-skeleton-loader>
                  </div>
                  <div class="pl-2 d-flex flex-wrap" v-if="!loading">
                    <v-checkbox
                      v-for="(shortPosition, index) in shortPositionsPlayed"
                      :value="shortPosition.position"
                      v-model="shortPositionsPlayedModel"
                      :key="index"
                      dense
                      hide-details
                      color="secondary"
                      class="mr-2 mt-0 py-1 body-2"
                      @change="onShortPositionChange(shortPosition.position);"
                    >
                      <template v-slot:label>
                        <span class="body-1 primary--text font-weight-medium">{{
                          `${getPositionCode(shortPosition.fieldPositionId)} (${shortPosition.minutesPlayed} min.)`
                        }}</span>
                      </template>
                    </v-checkbox>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="12" class="pt-0 pb-1" id="player-minmax-selector">
                <div class="d-flex flex-column">
                  <div
                    class="mr-5 pt-2 primary--text font-weight-bold body-1 d-flex align-center"
                  >
                    <span class="mr-1">{{ $t("playerRecruitment.minMax") }}</span>
                    <v-tooltip top color="lightSecondary lighten-4" max-width="300">
                      <template #activator="{on}">
                        <v-icon v-on="on" color="secondary" x-small
                        >info</v-icon>
                      </template>
                      <div class="d-flex flex-column align-center">
                        <span class="black--text body-1">{{$t("playerRecruitment.minMaxTooltip")}}</span>
                      </div>
                    </v-tooltip>
                  </div>
                  <div class="pl-2 d-flex flex-wrap">
                    <v-radio-group
                      @change="minMaxChange()"
                      v-model="minMaxModel"
                      row
                      class="mt-0 d-flex flex-column"
                    >
                      <v-radio
                        value="top5Leagues"
                        color="secondary"
                      >
                        <template v-slot:label>
                          <span class="body-1 primary--text font-weight-medium">{{
                            $t(`playerRecruitment.top5Leagues`)
                          }}</span>
                        </template>
                      </v-radio>
                      <v-radio
                        value="selectedSeason"
                        v-if="!seasonMinMaxRadioDisabled && !seasonMinMaxRadioLollipopDisabled"
                        color="secondary"
                      >
                        <template v-slot:label>
                          <span class="body-1 primary--text font-weight-medium">{{
                            $t(`playerRecruitment.selectedSeason`)
                          }}</span>
                        </template>
                      </v-radio>
                      <v-tooltip v-if="seasonMinMaxRadioDisabled" top color="lightSecondary lighten-4" max-width="300">
                        <template v-slot:activator="{ on }">
                          <v-radio
                            value="selectedSeason"
                            :readonly="true"
                            v-on="on"
                            color="secondary"
                          >
                            <template v-slot:label>
                              <span
                                v-on="on"
                                class="body-1 primary--text font-weight-medium"
                                >{{
                                  $t(`playerRecruitment.selectedSeason`)
                                }}</span
                              >
                            </template>
                          </v-radio>
                        </template>
                        <span class="black--text body-1">{{ $t(`playerRecruitment.infoMessage`) }}</span>
                      </v-tooltip>
                      <v-tooltip v-if="!seasonMinMaxRadioDisabled && seasonMinMaxRadioLollipopDisabled" top color="lightSecondary lighten-4" max-width="300">
                        <template v-slot:activator="{ on }">
                          <v-radio
                            :value="false"
                            :readonly="true"
                            v-on="on"
                            color="secondary"
                          >
                            <template v-slot:label>
                              <span
                                v-on="on"
                                class="body-1 primary--text font-weight-medium"
                                >{{
                                  $t(`playerRecruitment.selectedSeason`)
                                }}</span
                              >
                            </template>
                          </v-radio>
                        </template>
                        <span class="black--text body-1">{{ $t(`playerRecruitment.infoMessage2`) }}</span>
                      </v-tooltip>
                      <v-radio
                        value="ownSeason"
                        color="primary"
                        v-if="currentUserSeasonId && currentUserSeasonId != headerPlayer.seasonId"
                      >
                        <template v-slot:label>
                          <span class="body-1 primary--text font-weight-medium">{{
                            $t(`playerRecruitment.ownSeason`)
                          }}</span>
                        </template>
                      </v-radio>
                      <v-radio
                        value="champions"
                        v-if="isACTalentUser || isDLUsers"
                        color="secondary"
                      >
                        <template v-slot:label>
                          <span class="body-1 primary--text font-weight-medium">
                            A+/A
                          </span>
                        </template>
                      </v-radio>
                      <v-radio
                        value="europa"
                        v-if="isACTalentUser || isDLUsers"
                        color="secondary"
                      >
                        <template v-slot:label>
                          <span class="body-1 primary--text font-weight-medium">
                            B+
                          </span>
                        </template>
                      </v-radio>
                      <v-radio
                        value="ligaMX"
                        v-if="isOrlegiUser"
                        color="secondary"
                      >
                        <template v-slot:label>
                          <span class="body-1 primary--text font-weight-medium">
                            Liga MX
                          </span>
                        </template>
                      </v-radio>
                      <v-radio
                        value="segundaDivision"
                        v-if="isOrlegiUser"
                        color="secondary"
                      >
                        <template v-slot:label>
                          <span class="body-1 primary--text font-weight-medium">
                            Segunda División
                          </span>
                        </template>
                      </v-radio>
                      <v-radio
                        value="atmAcademyMinMax"
                        v-if="isATMAcademy"
                        color="secondary"
                      >
                        <template v-slot:label>
                          <span class="body-1 primary--text font-weight-medium">
                            ATM Academia
                          </span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </div>
                </div>
              </v-col>
              <!-- Compare Himself Zone -->
            </v-row>
            <v-row id="player-compare-zone">
              <v-col cols="12" class="pt-0 pb-2" v-if="!stackedView && selectedTab !== 'polar' && templateActive && !templateActive.cPD">
                <v-card-title class="pa-0 mb-0 header-font" style="font-size: 22px;">{{ $t('general.comparison') }}</v-card-title>
              </v-col>
              <v-col cols="12" class="py-0" v-if="!stackedView && selectedTab !== 'polar' && templateActive && !templateActive.cPD">
                <div
                  class="mr-5 primary--text font-weight-bold body-1"
                >
                  {{ $t("playerRecruitment.compareWith") }} {{ $t(`playerRecruitment.previousPerformance`)}}
                  <v-tooltip top color="lightSecondary lighten-4" max-width="300" v-if="!hasMinimumGames(20) || !hasMinimumGames(12)">
                    <template #activator="{on}">
                      <v-icon v-on="on" color="secondary" x-small>info</v-icon>
                    </template>
                    <span class="black--text body-1">{{$t(`playerDetail.gamesPlayedNotEnough`)}}</span>
                  </v-tooltip>
                  </div>
                  <v-radio-group row v-if="playerSeasonsPlayed && playerSeasonsPlayed.length" class="mt-1 pl-2 py-0" dense v-model="autoCompareModel" @change="onAutoCompareChange()">
                    <v-radio class="my-0 mr-1" value="-1" :label="$t('charts.lastSeasonSelectText')" :disabled="loading" color="secondary">
                      <template v-slot:label>
                        <span
                          class="body-1 primary--text font-weight-medium"
                          >{{$t('charts.lastSeasonSelectText')}}</span
                        >
                      </template>
                    </v-radio>
                    <v-radio class="my-0 mr-1" value="12" :disabled="!hasMinimumGames(20)" v-if="selectedTab !== 'performance-text'" color="secondary">
                      <template v-slot:label>
                        <span
                          class="body-1 primary--text font-weight-medium"
                          > {{$t('playerRecruitment.xGames',{0:12})}}</span
                        >
                      </template>
                    </v-radio>
                    <v-radio class="my-0 mr-1" value="6" :disabled="!hasMinimumGames(12)" v-if="selectedTab !== 'performance-text'" color="secondary">
                      <template v-slot:label>
                        <span
                          class="body-1 primary--text font-weight-medium"
                          >{{$t('playerRecruitment.xGames',{0:6})}}</span
                        >
                      </template>
                    </v-radio>
                  </v-radio-group>
              </v-col>
              <v-col cols="12" class="pt-1" v-if="playerSeasonsPlayed && selectedTab === 'radar'">
                 <div
                  class="mr-5 pt-0 mt-0 primary--text font-weight-bold body-1"
                >
                  {{ $t("playerRecruitment.compareWith") }} {{ $t('playerRecruitment.leagueAverage') }}
                </div>
                <v-autocomplete 
                  :items="leaguesAverage" 
                  return-object 
                  v-model="leaguesAverageObjectModel"
                  :placeholder="$t('playerRecruitment.selectSeason')"  
                  class="w-100"
                  hide-details 
                  dense 
                  clearable 
                  item-value="seasonId" 
                  item-text="seasonName"
                  @change="onLeagueAverageChange($event)">
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text" v-if="index <= 2">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="font-weight-bold">{{item.seasonName}}</span>
                    </v-chip>
                    <span
                          v-if="index === 3"
                          class="primary--text body-2 subheader-font"
                        >(+{{ seasonDataSelectedCheckBoxModel.length - 3 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <v-card-text
                      class="pa-0 primary--text body-1 font-weight-medium d-flex flex-column align-start justify-center">
                      <div>
                        <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                          <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                        </object>
                        <span>{{item.seasonName}}</span>
                      </div>
                      <span class="body-2 subheader-font">
                        {{item.teamName}} 
                        <span v-if="item.minutesPlayed" class="ms-1">{{ `(${item.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                      </span>
                    </v-card-text>
                  </template>
                </v-autocomplete>
              </v-col>
              <!-- Compare Player Zone -->
              <v-col cols="12" class="py-0" v-if="!stackedView && selectedTab !== 'polar'">
                <div
                  class="mr-5 primary--text font-weight-bold body-1"
                >
                  {{ $t("playerRecruitment.compareWith") }} <span v-if="!(isATMAcademy || isACTalentUser || isDLUsers)" class="mr-1">{{ templateActivePosition ? $t(`playerRecruitment.radarTemplates.${templateActivePosition}`) : "" }}</span>
                  <v-tooltip top color="lightSecondary lighten-4" max-width="300" v-if="templateActivePosition && !(isATMAcademy || isACTalentUser || isDLUsers)">
                    <template #activator="{on}">
                      <v-icon v-on="on" color="secondary" x-small
                      >info</v-icon>
                    </template>
                    <div class="d-flex flex-column align-center">
                      <span class="black--text body-1">{{$t(`playerDetail.onlyPlayersThatFit`)}} <b>{{ templateActivePosition ? $t(`playerRecruitment.radarTemplates.${templateActivePosition}`) : "" }}</b></span>
                      <div class="d-flex align-center">
                        <v-chip
                          class="monospace-font"
                          v-for="(pos,index) of getPositionsByTemplate()"
                          :key="index"
                          style="height: 20px; margin: 1px"
                          :color="getPositionChip(pos)"
                          text-color="white"
                          small
                        >{{ getPositionCode(pos) }}</v-chip>
                      </div>
                    </div>
                  </v-tooltip>
                </div>
                <div class="pl-2 d-flex flex-wrap">
                    <SearchBar
                      class="px-0 pt-0 mb-3 w-100"
                      placeholder="playerComparison.searchBarPlaceholder"
                      icon="person_add"
                      :dataSet="dataSetFiltered"
                      :navigate="false"
                      :playersResults="5"
                      :showTeams="false"
                      :showGames="false"
                      :showLeagues="false"
                      :showMore="false"
                      :noResultPlaceHolder="true"
                      :noResultPlaceHolderTemplate="$t(`playerRecruitment.radarTemplates.${templateActivePosition}`)"
                      @resultClicked="onResultClicked($event)"
                    ></SearchBar>
                </div>
                <div class="d-flex" v-if="selectedPlayer">
                  <PlayerSearchItem
                    :player="selectedPlayer"
                    class="mr-3 flex-grow-1"
                  ></PlayerSearchItem>
                  <v-icon @click="clearSearchItems()">cancel</v-icon>
                </div>
              </v-col>
              <v-col cols="12" class="pt-1" v-if="!stackedView && selectedTab !== 'polar' && comparePlayerSeasonData && comparePlayerSeasonData.length >= 8">
                 <div
                  class="mr-5 pt-0 mt-0 primary--text font-weight-bold body-1"
                >
                  {{ $t('app.seasonStats') }}
                </div>
                <v-autocomplete clearable v-if="showSeasonsAsCheckbox" :items="comparePlayerSeasonDataFiltered"
                  v-model="seasonDataComparePlayerSelectedCheckBoxModel" multiple hide-details dense item-value="compoundId"
                  item-text="compoundText"
                  @change="onAutoCompleteCompareSeasonChange($event)">
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text" v-if="index <= 2">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="font-weight-bold">{{item.seasonName}}</span>
                      <span class="mx-1">@</span>
                      <span class="font-weight-medium">{{item.teamName}}</span>
                    </v-chip>
                    <span
                          v-if="index === 3"
                          class="primary--text body-2 subheader-font"
                        >(+{{ seasonDataSelectedCheckBoxModel.length - 3 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <v-card-text
                      class="px-0 py-1 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center">
                      <div>
                        <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                          <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                        </object>
                        <span>{{item.seasonName}}</span>
                      </div>
                      <span class="body-2 subheader-font">
                        {{item.teamName}} 
                        <span v-if="item.minutesPlayed" class="ms-1">{{ `(${item.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                      </span>
                    </v-card-text>
                  </template>
                </v-autocomplete>
                <v-autocomplete clearable v-if="!showSeasonsAsCheckbox" :items="comparePlayerSeasonDataFiltered"
                  v-model="seasonDataComparePlayerSelectedRadiosModel" hide-details dense item-value="compoundId" item-text="compoundText"
                  @change="onAutoCompleteCompareSeasonChange($event)">
                  <template v-slot:selection="{item}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="font-weight-bold">{{item.seasonName}}</span>
                      <span class="mx-1">@</span>
                      <span class="font-weight-medium">{{item.teamName}}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{item}">
                    <v-card-text
                      class="px-0 py-1 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center">
                      <div>
                        <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                          <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                        </object>
                        <span>{{item.seasonName}}</span>
                      </div>
                      <span class="body-2 subheader-font">
                        {{item.teamName}} 
                        <span v-if="item.minutesPlayed" class="ms-1">{{ `(${item.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                      </span>
                    </v-card-text>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                v-if="!stackedView && selectedTab !== 'polar' && showSeasonsAsCheckbox && comparePlayerSeasonData && comparePlayerSeasonData.length < 8"
                class="d-flex py-0 pr-1 flex-column"
                cols="12"
              >
                <v-checkbox
                  :key="index"
                  v-for="(seasonData,
                  index) in comparePlayerSeasonDataCurrentYear"
                  :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                  v-model="seasonDataComparePlayerSelectedCheckBoxModel"
                  :disabled="seasonData.disabled"
                  class="px-2 mt-0 py-1"
                  color="secondary"
                  hide-details
                  @change="onComparePlayerSeasonChange(seasonData)"
                >
                  <template v-slot:label>
                    <v-card-text
                      class="pa-0 primary--text body-1 font-weight-medium d-flex flex-column align-start justify-center">
                      <div>
                        <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                          <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                        </object>
                        <span>{{seasonData.seasonName}}</span>
                      </div>
                      <span class="body-2 subheader-font">
                        {{seasonData.teamName}} 
                        <span v-if="seasonData.minutesPlayed" class="ms-1">{{ `(${seasonData.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                      </span>
                    </v-card-text>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col
                v-if="!stackedView && selectedTab !== 'polar' &&
                  !showSeasonsAsCheckbox &&
                  comparePlayerSeasonDataCurrentYear.length > 0 && comparePlayerSeasonData.length < 8"
                class="d-flex py-0 pr-1"
                cols="12"
                v-for="(seasonData, index) in comparePlayerSeasonDataCurrentYear"
                :key="index"
              >
                <v-radio-group
                  @change="onComparePlayerSeasonChange(seasonData)"
                  :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                  v-model="seasonDataComparePlayerSelectedRadiosModel"
                  row
                  dense
                  hide-details
                  class="mt-0 d-flex flex-column"
                >
                  <v-radio
                    :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                    :key="index"
                    class="px-2 mt-0"
                    color="secondary"
                    :disabled="seasonData.disabled"
                  >
                    <template v-slot:label>
                      <v-card-text
                        class="pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center">
                        <div>
                          <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                            <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                          </object>
                          <span>{{seasonData.seasonName}}</span>
                        </div>
                        <span class="body-2 subheader-font">
                          {{seasonData.teamName}} 
                          <span v-if="seasonData.minutesPlayed" class="ms-1">{{ `(${seasonData.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                        </span>
                      </v-card-text>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col class="d-flex py-0 align-start pr-0" cols="12" v-if="!stackedView && selectedTab !== 'polar' && comparePlayerSeasonData && comparePlayerSeasonData.length < 8">
                <v-row v-if="comparePlayerSeasonDataLastYear">
                  <v-col
                    v-if="showSeasonsAsCheckbox"
                    class="d-flex py-0 pr-1"
                    cols="12"
                    sm="12"
                    v-for="(seasonData,
                    index) in comparePlayerSeasonDataLastYear"
                    :key="index"
                  >
                    <v-checkbox
                      :key="index"
                      :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                      v-model="seasonDataComparePlayerSelectedCheckBoxModel"
                      :disabled="seasonData.disabled"
                      hide-details
                      class="px-2 mt-0 py-1"
                      color="secondary"
                      @change="onComparePlayerSeasonChange(seasonData)"
                    >
                      <template v-slot:label>
                        <v-card-text
                          class="pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center">
                          <div>
                            <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                              <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                            </object>
                            <span>{{seasonData.seasonName}}</span>
                          </div>
                          <span class="body-2 subheader-font">
                            {{seasonData.teamName}} 
                            <span v-if="seasonData.minutesPlayed" class="ms-1">{{ `(${seasonData.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                          </span>
                        </v-card-text>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col
                    v-if="!showSeasonsAsCheckbox"
                    class="d-flex py-0 pr-1"
                    cols="12"
                    sm="12"
                    v-for="(seasonData, index) in comparePlayerSeasonDataLastYear"
                    :key="index"
                  >
                    <v-radio-group
                      @change="onComparePlayerSeasonChange(seasonData)"
                      :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                      v-model="seasonDataComparePlayerSelectedRadiosModel"
                      row
                      dense
                      hide-details
                      class="mt-0 py-0 d-flex flex-column"
                    >
                      <v-radio
                        :value="`${seasonData.seasonId}-${seasonData.teamId}`"
                        :key="index"
                        class="px-2 mt-0 py-1"
                        color="secondary"
                        :disabled="seasonData.disabled"
                      >
                        <template v-slot:label>
                          <v-card-text
                            class="pa-0 primary--text body-2 font-weight-medium d-flex flex-column align-start justify-center">
                            <div>
                              <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${seasonData.leagueId}.png`"  type="image/png" height="18" class="mr-2">
                                <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="15">
                              </object>
                              <span>{{seasonData.seasonName}}</span>
                            </div>
                            <span class="body-2 subheader-font">
                              {{seasonData.teamName}} 
                              <span v-if="seasonData.minutesPlayed" class="ms-1">{{ `(${seasonData.minutesPlayed} ${$t('table.history.minutes')})` }}</span>
                            </span>
                          </v-card-text>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="!stackedView && selectedTab !== 'polar' && shortPositionsPlayedComparePlayer.length > 0 && templateActive && !templateActive.cPD"
                cols="12"
                sm="12"
                class="pt-0 pb-1"
              >
                <div class="d-flex flex-column">
                  <div
                    class="mr-5 pt-2 primary--text font-weight-bold body-2"
                  >
                    {{ $t("playerRecruitment.positionsPlayed") }}
                  </div>
                  <div class="pl-2 d-flex flex-wrap">
                    <v-checkbox
                      v-for="(shortPosition,
                      index) in shortPositionsPlayedComparePlayer"
                      :value="shortPosition.position"
                      v-model="shortPositionsPlayedComparePlayerModel"
                      :key="index"
                      dense
                      hide-details
                      class="mr-2 mt-0 py-1 body-2"
                      color="secondary"
                      @change="onCompareShortPositionChange(shortPosition.position)"
                    >
                      <template v-slot:label>
                        <span class="body-1 primary--text font-weight-medium">{{
                          `${getPositionCode(shortPosition.fieldPositionId)} (${shortPosition.minutesPlayed} min.)`
                        }}</span>
                      </template>
                    </v-checkbox>
                  </div>
                </div>
              </v-col>
              <!-- End Col Compare Player -->
              <v-col cols="12" class="pb-2 px-1" v-if="!stackedView">
                <v-divider></v-divider>
              </v-col>
              <v-col class="d-flex justify-end py-0 px-2" cols="12" v-if="selectedTab !== 'performance-text'" id="player-download-zone">
                <v-btn rounded class="mr-1 ml-0 d-flex align-center elevation-0 monospace-font white--text" color="secondary"
                  small
                  v-on:click.native="saveAsPNG()"
                >
                  <v-icon small class="mr-1">
                    file_download</v-icon
                  >
                  <span class="">PNG</span>
                </v-btn>
                <v-btn
                  rounded class="mr-1 ml-0 elevation-0 monospace-font white--text" color="secondary"
                  small
                  v-on:click.native="saveAsSVG()"
                >
                  <v-icon small class="mr-1"
                    >file_download</v-icon
                  >
                  <span>SVG</span>
                </v-btn>
                <v-btn
                  rounded class="mr-1 ml-0 elevation-0 monospace-font white--text" color="secondary"
                  small
                  :loading="loadingExport"
                  :disabled="loading"
                  v-on:click.native="onGenerateIFrameClick()"
                >
                  <v-icon small class="mr-1"
                    >share</v-icon
                  >
                  <span>Embed</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-if="!loading && !searchesLimitReached"
        cols="12"
        :md="stackedView ? 12 : 8"
        :order="stackedView ? 2 : 3"
        id="chart"
        ref="chart"
        class="text-center pl-0 pb-0 pt-1"
      >
        <v-btn-toggle
          id="player-chart-selector"
          v-model="selectedTab"
          tile
          :color="`${darkMode ? 'lightSecondary' : 'secondary'}`"
          group
          dense
          mandatory
          @change="onTabChange($event)"
          class="d-flex w-100 align-center justify-center flex-wrap pb-3"
        >
          <v-btn value="radar" class="">
            <v-icon :small="$vuetify.breakpoint.smAndDown">wifi_tethering</v-icon>
            <span v-if="$vuetify.breakpoint.lgAndUp" class="body-2 text-lg-button">{{ $t("playerRecruitment.radar") }}</span>
          </v-btn>
          <v-btn value="polar" class="">
            <v-icon :small="$vuetify.breakpoint.smAndDown">donut_small</v-icon>
            <span v-if="$vuetify.breakpoint.lgAndUp" class="body-2 text-lg-button">{{ $t("playerRecruitment.polar") }}</span>
          </v-btn>
          <v-btn value="lollipop" class="">
            <v-icon :small="$vuetify.breakpoint.smAndDown">stacked_bar_chart</v-icon>
            <span v-if="$vuetify.breakpoint.lgAndUp" class="body-2">{{ $t("playerRecruitment.lollipop") }}</span>
          </v-btn>
          <v-btn value="performance-text" class="">
            <v-icon :small="$vuetify.breakpoint.smAndDown">reorder</v-icon>
            <span v-if="$vuetify.breakpoint.lgAndUp" class="body-2 text-lg-button">{{ $t("playerRecruitment.text") }}</span>
          </v-btn>
        </v-btn-toggle>
        <v-alert dense type="warning" border="left" v-if="radarData && radarData.minutesPlayed < 450 && size != 0 &&
        (radarData || mainPlayerRadarData || comparePlayerRadarData) && shortPositionsPlayed && shortPositionsPlayed.length" class="mt-2 mx-5 mb-0 py-1 body-1 font-weight-medium">
          {{$t("playerDetail.warningMinutes")}}
          <br>
          <span v-if="minMaxModel !== 'top5Leagues' && !seasonSelectedMainPlayerMoreThan5GamesPlayed">{{$t("playerDetail.warningSeasonGames")}}</span>
        </v-alert>
        <v-alert dense type="warning" border="left" v-if="radarData.statsRemoved" class="mt-2 mx-5 mb-0 py-1 body-1 font-weight-medium">
          {{$t("playerDetail.warningStatsRemoved")}}
        </v-alert>
        <!-- Render PlayerAvatarMedia when Media Mode switch is true for Radar or Lollipop -->
        <PlayerAvatarMedia v-if="player && avatarSize && mediaMode && selectedTab !== 'performance-text'"
          :player="player" :width="size" :height="avatarSize.height" :id="`${player.playerId}-${this.radarId}`"
          :key="playerAvatarMediaKey" :margin="margin" :title="mediaModeData.upperText" :subtitle="mediaModeData.lowerText"
          :color="mediaModeData.borderColor" ref="playerAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :comparisonPlayerData="comparePlayerData" :comparisonTitle="mediaModeData.comparisonUpperText" :comparisonSubtitle="mediaModeData.comparisonLowerText" :comparisonColor="mediaModeData.comparisonBorderColor"
          :type="selectedTab"
          :face="mediaModeData.face.src"
          :comparisonFace="mediaModeData.comparisonFace.src"
          :nationalTeam="mediaModeData.nationalTeam"
          :lineDistance="mediaModeData.lineLength" :lineWeight="mediaModeData.lineWeight" :avatarSize="mediaModeData.avatarSize"
          :upperTextFontSize="mediaModeData.upperTextFontSize" :upperTextFontWeight="mediaModeData.upperTextFontWeight"
          :lowerTextFontSize="mediaModeData.lowerTextFontSize" :lowerTextFontWeight="mediaModeData.lowerTextFontWeight"
          :fontFamily="mediaModeData.fontFamily"
          :team="team"
          class="mt-2"/>
        <RadarChart
          v-if="player && size != 0 && radarData != null && selectedTab === 'radar' && !loading"
          :id="`${player.playerId}-${this.radarId}`"
          ref="radarRef"
          :key="chartKey"
          :size="size"
          :margin="margin"
          :radarData="radarData"
          :darkMode="darkMode"
          :dataPer90MinText="dataPer90MinText"
          :adjustToPossessionText="adjustToPossessionText"
          :playerName="player.name"
          :radarTitle="radarTitle"
          :yob="yob"
          :comparePlayerData="comparePlayerData"
          :mediaMode="mediaMode"
          :colors="radarColors"
          :bgColor="mediaMode ? mediaModeData.bgColor : defaultColors.bgColor"
          :textColor="mediaModeData.textColor"
          :axisColor="mediaModeData.axisColor"
          :logoCfg="mediaModeData.logo"
          :fontFamily="mediaModeData.fontFamily"
          v-bind:class="{'mt-2':!mediaMode}"
          @sizeChange="onRadarSizeChange($event)"
          :showRadarIcons="showRadarIcons" />
        <!--Product icons-->
        <div cols="12" class="py-5 d-flex justify-center" v-if="!loading && showRadarIcons && selectedTab === 'radar'">
          <p class="my-0 me-5 subheader-font body-2 monospace-font"><v-icon small class="me-1" style="font-size: 16px">tune</v-icon>{{ $t('roles.ROLE_EVENTING_DATA') }}</p>
          <p class="my-0 me-5 subheader-font body-2 monospace-font"><v-icon small class="me-1" style="font-size: 16px">speed</v-icon>{{ $t('roles.ROLE_PHYSICAL_DATA') }}</p>
          <p class="my-0 me-5 subheader-font body-2 monospace-font"><v-icon small class="me-1" style="font-size: 12px">fa-wand-magic-sparkles</v-icon>{{ $t('roles.ROLE_ARRIGO') }}</p>
        </div>
        <LollipopChart
          v-if="lollipopData && !lollipopData.statDTOs[1] && size != 0 && selectedTab === 'lollipop' && !loading"
          :id="`${player.playerId}-${this.radarId}`"
          ref="lollipopRef"
          :key="chartKey"
          :size="size"
          :chartData="lollipopData"
          :dataPer90MinText="dataPer90MinText"
          :adjustToPossessionText="adjustToPossessionText"
          :playerName="player.name"
          :radarTitle="radarTitle"
          :yob="yob"
          :minMaxLabel="lollipopMinMaxLabel"
          :mediaMode="mediaMode"
          :colors="radarColors"
          :bgColor="mediaMode ? mediaModeData.bgColor : defaultColors.bgColor"
          :textColor="mediaModeData.textColor"
          :axisColor="mediaModeData.axisColor"
          :logoCfg="mediaModeData.logo"
          :fontFamily="mediaModeData.fontFamily"
          @sizeChange="onRadarSizeChange($event)"
          />
        <CompareLollipopChart
          v-if="lollipopData && lollipopData.statDTOs[1] && size != 0 && selectedTab === 'lollipop' && !loading"
          :id="`${player.playerId}-${this.radarId}`"
          ref="compareLollipopRef"
          :key="chartKey"
          :size="size"
          :chartData="lollipopData"
          :dataPer90MinText="dataPer90MinText"
          :adjustToPossessionText="adjustToPossessionText"
          :playerName="player.name"
          :radarTitle="radarTitle"
          :yob="yob"
          :minMaxLabel="lollipopMinMaxLabel"
          :comparePlayerData="comparePlayerData"
          :mediaMode="mediaMode"
          :colors="radarColors"
          :bgColor="mediaMode ? mediaModeData.bgColor : defaultColors.bgColor"
          :textColor="mediaModeData.textColor"
          :axisColor="mediaModeData.axisColor"
          :fontFamily="mediaModeData.fontFamily"
          :logoCfg="mediaModeData.logo"/>
        <RadarDescription v-show="selectedTab === 'performance-text' && mainPlayerRadarData != null && seasonIdsMainPlayerSelected"
          v-if="playerProfiles && templateActivePosition"
          :radarData="mainPlayerRadarData"
          :seasonMoreMinutesPlayedYear="seasonMoreMinutesPlayedYear"
          :leagueIdWithMoreMinutesPlayed="leagueIdWithMoreMinutesPlayed"
          :leagueLabelWithMoreMinutesPlayed="leagueLabelWithMoreMinutesPlayed ? leagueLabelWithMoreMinutesPlayed.toString() : leagueLabelWithMoreMinutesPlayed"
          :seasonIds="seasonIdsMainPlayerSelected"
          :player="player"
          :playerProfiles="playerProfiles"
          :radarTemplate="templateActivePosition"/>
        <RadarDescription v-show="selectedTab === 'performance-text' && comparePlayerRadarData != null && seasonIdsComparePlayerSelected"
          v-if="comparePlayerProfiles && templateActivePosition"
          :radarData="comparePlayerRadarData"
          :seasonMoreMinutesPlayedYear="seasonMoreMinutesPlayedComparePlayerYear"
          :leagueIdWithMoreMinutesPlayed="leagueIdWithMoreMinutesPlayedComparePlayer"
          :leagueLabelWithMoreMinutesPlayed="leagueLabelWithMoreMinutesPlayedComparePlayer ? leagueLabelWithMoreMinutesPlayedComparePlayer.toString() : leagueLabelWithMoreMinutesPlayedComparePlayer"
          :seasonIds="seasonIdsComparePlayerSelected"
          :player="selectedPlayer"
          :playerProfiles="comparePlayerProfiles"
          :radarTemplate="templateActivePosition"/>
        <PolarChart
          v-if="player && size != 0 && polarData != null && selectedTab === 'polar'"
          :id="`${player.playerId}-${this.radarId}`"
          :size="size"
          :margin="margin"
          :polarData="polarData"
          :darkMode="darkMode"
          :dataPer90MinText="dataPer90MinText"
          :adjustToPossessionText="adjustToPossessionText"
          :playerName="player.name"
          :polarTitle="radarTitle"
          :yob="yob"
          :key="chartKey"
          :mediaMode="mediaMode"
          :colors="radarColors"
          :bgColor="mediaMode ? mediaModeData.bgColor : defaultColors.bgColor"
          :textColor="mediaModeData.textColor"
          :axisColor="mediaModeData.axisColor"
          :logoCfg="mediaModeData.logo"
          :fontFamily="mediaModeData.fontFamily"
          v-bind:class="{'mt-2':!mediaMode}"
          @sizeChange="onRadarSizeChange($event)"/>
        <!-- Render DriblabSocialMedia when Media Mode switch is true for Radar or Lollipop -->
        <DriblabSocialMedia v-if="player && size && mediaMode && mediaModeData.socialMedia && selectedTab !== 'performance-text'"
          :width="size" :height="50" :id="`${player.playerId}-${this.radarId}`"
          :key="socialMediaKey" :margin="margin" ref="driblabSocialMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :fontSize="mediaModeData.socialMediaFontSize" :fontWeight="mediaModeData.socialMediaFontWeight"
          :logoCfg="mediaModeData.logo"
          :sponsor="mediaModeData.sponsor.dataUrl"
          :fontFamily="mediaModeData.fontFamily"
          :type="selectedTab"/>
      </v-col>
      <v-col v-if="loading"
        cols="12"
        :md="stackedView ? 12 : 8"
        :order="stackedView ? 2 : 3"
        id="chart"
        ref="chart"
        class="text-center pb-0 pt-4 d-flex align-center flex-column"
      >
        <span class="mb-3 primary--text monospace-font">{{$t("loadingMessages.placeholder")}}...</span>
        <v-skeleton-loader type="avatar" class="big-avatar-skeleton"></v-skeleton-loader>
      </v-col>
      <v-col v-if="!loading && searchesLimitReached"
        cols="12"
        :md="stackedView ? 12 : 7"
        :order="stackedView ? 2 : 3"
        class="py-0">
        <v-col cols="12" class="d-flex flex-column justify-center align-center">
          <v-icon style="font-size:15rem" color="primary lighten-5">lock</v-icon>
          <span class="text-h4 primary--text" >You have reached the limit of searches per day for the demo period.</span>
          <span class="text-h5 subheader-font mt-2">Contact the Driblab team to obtain unlimited searches. Your account will be reopened tomorrow.</span>
          <v-btn to="/home" color="secondary" class="elevation-0 monospace-font white--text px-5 mt-5" rounded>GO HOME</v-btn>
        </v-col>
      </v-col>
    </v-row>
    <RadarTemplateFormModal
      ref="formModalRef"
      :title="$t('settings.radarTemplates')"
      :subtitle="$t('settings.radarTemplatesSubtitle')"
      :positionId="player.positionId"
      @save="getRadarTemplates()"
    />
    <ChartExportLinksModal ref="chartExportLinksModalRef" :title="player.name"
    :subtitle="this.selectedTab === 'radar' || this.selectedTab === 'polar' ? $t('playerRecruitment.radar') : $t('playerRecruitment.lollipop')"></ChartExportLinksModal>
    <Tour v-if="currentUser.showTour" name="playerRadarTour" :steps="tourSteps" />
  </v-container>
</template>

<script>

import * as moment from 'moment';
//Import Services
import PlayerService from "../../services/player/player.service";
import UserService from "../../services/user.service";
import UserChartService from "../../services/user-chart.service";
import DocumentService from "../../services/document.service";
import PlayerRadarService from "../../services/player/playerRadar.service";
import SeasonService from "../../services/season.service";
import LeagueService from "../../services/league.service";
//Import Components
import RadarChart from "../base/RadarChart";
import LollipopChart from "../base/LollipopChart";
import CompareLollipopChart from "../base/CompareLollipopChart";
import PolarChart from "../base/PolarChart";
import MediaModeForm from "../base/MediaModeForm";
import ChartExportLinksModal from "../base/ChartExportLinksModal";
import PlayerAvatarMedia from "./PlayerAvatarMedia";
import RadarDescription from "../base/RadarDescription";
import DriblabSocialMedia from "../base/DriblabSocialMedia";
import SearchBar from "../base/SearchBar";
import PlayerSearchItem from "../player/PlayerSearchItem";
import Tour from "../base/Tour";
import RadarTemplateFormModal from "../modals/RadarTemplateFormModal";
import CATEGORIES_ORDER from "./categories_order";
import { capitalizeFirstLetter, getShortPositionsByTemplate,
  getChipColorByPosition, userHasRole,
  getPositionCode, getSupervisedItems, getRadarTemplateSubtitle, getRadioStyle } from "../../utils/functions";
import { exportSvg, downloadPng, copyAndAppendElement }  from '../../utils/exportToPNG';
import { v4 } from 'uuid';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8081';

const API_URL = NODE_ENV === 'production' ? 'https://pro.driblab.com/embed-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/embed-chart/'

export default {
  name: "PlayerRadar",
  components: {
    RadarChart,
    LollipopChart,
    CompareLollipopChart,
    PolarChart,
    SearchBar,
    PlayerSearchItem,
    RadarDescription,
    PlayerAvatarMedia,
    DriblabSocialMedia,
    MediaModeForm,
    ChartExportLinksModal,
    Tour,
    RadarTemplateFormModal
  },
  watch: {
    "mediaMode": function(newVal, oldVal) {
      if(!this.mediaMode){
        this.mediaModeData = { // borderColor:"#1232DC",fillColor:"#1232DC"
          borderColor:"#3366FF", fillColor:"#6D7DE5", bgColor:"#ffffff0",upperText:null,lowerText:null,
          socialMedia:true,nationalTeam: false,textColor: this.defaultColors.textColor,axisColor:this.defaultColors.axisColor,logo:"color",
          comparisonBorderColor:"#000000",comparisonFillColor:"#7D7D7D",comparisonUpperText:null,comparisonLowerText: null,face:{},comparisonFace:{},
          upperTextFontWeight:"900",lowerTextFontWeight:"400",socialMediaFontWeight:"300",socialMediaFontSize:"14",sponsor:{}}
      }else{
        this.mediaModeData.axisColor = this.defaultColorsMediaMode.axisColor
        this.mediaModeData.textColor = this.defaultColorsMediaMode.textColor
      }
      this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
      this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0.png`;
      this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
      this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      this.mediaModeData.bgColor = this.mediaMode ? '#ffffff' : '#ffffff0';
      this.updateChartsByRef();
    }
  },
  props:{
    playerId:{
      type: Number,
      required: false
    },
    stackedView:{
      type: Boolean,
      required: false
    },
    radarId:{
      type: Number,
      default: 0
    },
    headerPlayer:{
      type: Object,
      required: false
    },
    headerPlayerSeasonData:{
      type: Array,
      required: false
    }
  },
  data() {
    return {
      //True if limited user has reached daily limit of searches
      searchesLimitReached: false,
      //True when season without physical data is selected. Used for disabled radars
      physicalRadarDisabled: false,
      //True when season without arrigo data is selected. Used for disabled radars
      arrigoRadarDisabled: false,
      darkMode: this.$store.state.auth.user.darkMode || this.$vuetify.theme.dark,
      dataPer90MinText: this.$t("playerRecruitment.dataPer90MinText"),
      adjustToPossessionText: this.$t("playerRecruitment.adjustToPossessionText"),
      selectedTab: "radar",
      dataSetAllPlayers: null,
      dataSetFiltered: null,
      selectedPlayer: null,
      size: 0,
      prevWindowWidth: 0,
      prevWindowHeight: 0,
      margin: null,
      radarData: null,
      mainPlayerRadarData: null,
      comparePlayerRadarData: null,
      players: [],
      playerProfiles: null,
      comparePlayerProfiles: null,
      yob: "0",
      language: "",
      chartKey: 0,
      socialMediaKey: 1,
      playerAvatarMediaKey: 2,
      player: null,
      radars: [],
      shortPositionsPlayed: [],
      shortPositionsPlayedModel: [],
      leagues: [],
      seasonMoreMinutesPlayedYear: 2020,
      leagueIdWithMoreMinutesPlayed: 1,
      leagueLabelWithMoreMinutesPlayed: "La Liga",
      radarTitle: "",
      infoMessage: this.$t("playerRecruitment.infoMessage"),
      minMaxModel: "top5Leagues",
      seasonMinMaxRadioDisabled: false,
      seasonMinMaxRadioLollipopDisabled: false,
      seasonDataSelectedCheckBoxModel: [],
      seasonSelectedMainPlayerMoreThan5GamesPlayed: true,
      //Season selected when radio buttons are visible
      seasonDataSelectedRadiosModel: null,
      playerSeasonData: [],
      currentYear: null,
      playerSeasonDataCurrentYear: [],
      playerSeasonDataLastYear: [],
      templateActiveId: null,
      templates: [],
      positionIdOfTemplateActive: 0,
      seasonIdsMainPlayerSelected: [],
      //Data Compare Player
      comparePlayerMinsPlayed: 0,
      comparePlayerYob: "0",
      shortPositionsPlayedComparePlayer: [],
      shortPositionsPlayedComparePlayerModel: [],
      seasonMoreMinutesPlayedComparePlayerYear: 2020,
      leagueIdWithMoreMinutesPlayedComparePlayer: 1,
      leagueLabelWithMoreMinutesPlayedComparePlayer: "La Liga",
      comparePlayerSeasonData: [],
      comparePlayerSeasonDataCurrentYear: [],
      comparePlayerSeasonDataLastYear: [],
      seasonDataComparePlayerSelectedCheckBoxModel: [],
      seasonDataComparePlayerSelectedRadiosModel: null,
      comparePlayerData: null,
      seasonIdsComparePlayerSelected: [],
      leaguesAverageObjectModel: null,
      //Average seasons
      averageSeasons: [],
      avatarSize: null,
      radarSize: null,
      mediaMode: null,
      mediaModeFlags: {
                      borderColor:null, fillColor:null, bgColor:null, upperText:null, lowerText:null,
                      socialMedia:null, nationalTeam: null,textColor: null,axisColor:null,logo:null,
                      comparisonBorderColor:null,comparisonFillColor:null,comparisonUpperText:null,
                      comparisonLowerText: null,face: null,comparisonFace:null
                      },
      mediaModeData: { //borderColor:"#1232DC",fillColor:"#1232DC" borderColor:"#77a1d3",fillColor:"#77a1d3"
                      borderColor:"#3366FF", fillColor:"#6D7DE5", bgColor:"#ffffff0", upperText:null, lowerText:null,
                      socialMedia:true, nationalTeam: false, textColor:"#000", axisColor:"#fff",
                      logo:"color", comparisonBorderColor:"#000000", comparisonFillColor:"#7D7D7D", comparisonUpperText:null, comparisonLowerText: null,
                      face: {}, comparisonFace:{}, upperTextFontWeight:"900", lowerTextFontWeight:"400", fontFamily:"NeueMontreal",
                      socialMediaFontWeight:"300", socialMediaFontSize:"12", sponsor:{}
                    },
      mediaModeFields: [
        {type:"text",label:"mediaMode.upperText",key:"upperText"},
        {type:"number",label:"mediaMode.upperTextFontSize",key:"upperTextFontSize"},
        {type:"radio",label:"mediaMode.upperTextFontWeight",key:"upperTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"text",label:"mediaMode.lowerText",key:"lowerText"},
        {type:"number",label:"mediaMode.lowerTextFontSize",key:"lowerTextFontSize"},
        {type:"radio",label:"mediaMode.lowerTextFontWeight",key:"lowerTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"radio",label:"mediaMode.fontFamily",key:"fontFamily",options:[{value:"NeueMontreal",label:"NeueMontreal"},{value:"NeueMontreal",label:"NeueMontreal"}]},
        {type:"color",label:"mediaMode.textColor",key:"textColor"},
        {type:"color",label:"mediaMode.borderColor",key:"borderColor"},
        {type:"color",label:"mediaMode.fillColor",key:"fillColor"},
        {type:"color",label:"mediaMode.bgColor",key:"bgColor"},
        {type:"color",label:"mediaMode.axisColor",key:"axisColor"},
        {type:"radio",label:"mediaMode.logo",key:"logo",options:[{value:"color",label:"Color"},{value:"white",label:"general.white"},{value:"none",label:"favorites.noGrouped"}]},
        {type:"number",label:"mediaMode.avatarLineLength",key:"lineLength",force:true},
        {type:"number",label:"mediaMode.avatarLineWeight",key:"lineWeight",force:true},
        {type:"number",label:"mediaMode.avatarSize",key:"avatarSize",force:true},
        {type:"image",label:"mediaMode.face",key:"face"},
        {type:"switch",label:"mediaMode.nationalTeam",key:"nationalTeam"},
        {type:"switch",label:"mediaMode.socialMedia",key:"socialMedia"},
        {type:"number",label:"mediaMode.socialMediaFontSize",key:"socialMediaFontSize",force:true},
        {type:"radio",label:"mediaMode.socialMediaFontWeight",key:"socialMediaFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}],force:true},
        {type:"image",label:"mediaMode.sponsor",key:"sponsor",force:true,aspectRatio:16/9,imageRestriction:'none',resizable:true,stencilSize:{width:300,height:300}}
      ],
      autoCompareModel: null,
      loading: false,
      loadingExport: false,
      mainPlayerTimeOut: null,
      comparisonPlayerTimeOut: null,
      allGamesModel: true
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserLanguage() {
      return this.$store.getters["auth/language"];
    },
    currentUserDefaultVisualization() {
      return this.$store.getters["auth/defaultVisualization"];
    },
    showAutocomplete() {
      return this.playerSeasonData.length >= 8;
    },
    showPhysicalTemplates(){
      //Show physical data just if some player season has physical data and user has role ROLE_PHYSICAL_DATA
      return this.playerSeasonDataFiltered.some(ps => ps.hasPhysicalData) && this.userHasRole("ROLE_PHYSICAL_DATA"); 
    },
    showArrigoTemplates(){
      //Show arrigo data just if some player season has physical data and user has role ROLE_ARRIGO
      return this.playerSeasonDataFiltered.some(ps => ps.hasArrigoData) && this.userHasRole("ROLE_ARRIGO"); 
    },
    //Current Radar selected, full object
    templateActive(){
      if(this.templates.length && this.templateActiveId){
        return this.templates.find(t => t.radarId === this.templateActiveId);
      }
      return;
    },
    //Position of current radar selected
    templateActivePosition(){
      if(this.templateActive){
        return this.templateActive.position;
      }
      return;
    },
    radarColors(){
      //MediaMode colors
      let borderColor = this.mediaModeData.borderColor,
      fillColor = this.mediaModeData.fillColor;
      //if not media mode, get colors depending of Radar XY, Physical or Arrigo
      if(!this.mediaMode){
        if(this.templateActive.cPD){
          borderColor = "#357A38";
          fillColor = "#4CAF50";
        }else if(this.templateActive.cA){
          borderColor = "#3396F3";
          fillColor = "#77A1D3";
        };
      };

      return {
        borderColor: borderColor,
        fillColor: fillColor,
        comparisonBorderColor: this.mediaModeData.comparisonBorderColor,
        comparisonFillColor: this.mediaModeData.comparisonFillColor
      }
    },
    defaultColors(){
      return {
        textColor: this.darkMode ? "#fff" : "#000",
        axisColor: this.darkMode ? "#2a2a2a" : "#fff",
        bgColor: "transparent"
      }
    },
    defaultColorsMediaMode(){
      return {
        textColor: this.darkMode ? "#fff" : "#000",
        axisColor: this.darkMode ? "#2a2a2a" : "#fff"
      }
    },
    lollipopData(){
      if(this.radarData && this.positionIdOfTemplateActive > 0){
        let lollipopData = _.cloneDeep(this.radarData);
        if(this.selectedTab === "lollipop"){
          lollipopData.statDTOs[0] = this.getCategoryOrderByPosition(lollipopData.statDTOs[0]);
          //If there is compare player, order too
          if(lollipopData.statDTOs[1]){
            //Avoid compare lollipop with average league
            lollipopData.statDTOs[1] = this.leaguesAverageObjectModel ? null : this.getCategoryOrderByPosition(lollipopData.statDTOs[1]);
          }
        }
        return lollipopData;
      }
    },
    playerSeasonsPlayed(){
      if(this.templateActive){
        this.playerSeasonData.forEach(season => {
          //Disable season if: 
          //      selected template has Physical Stats & season has no PD
          //      selected template has Arrigo Stats & season has no Arrigo Data
          season.disabled = (this.templateActive.cPD && !season.hasPhysicalData) || 
                            (this.templateActive.cA && !season.hasArrigoData);
        });
      }
      return this.playerSeasonData;
    },
    //Filter to remove seasons not hired by the client
    playerSeasonDataFiltered() {
      let dataFiltered = _.cloneDeep(this.playerSeasonsPlayed);
      if(this.templateActive){
        dataFiltered = dataFiltered.filter(s=> this.templateActive.cXY || 
                                            (this.templateActive.cPD && s.hasPhysicalData) || 
                                            (this.templateActive.cA && s.hasArrigoData)
                                        );
      }
      return dataFiltered;
    },
    //Method that add seasons to Compare with League Average
    leaguesAverage() {
      if(this.playerSeasonData.length){
        let dataFiltered = _.cloneDeep(this.playerSeasonData);

        //1.- Add all client seasons
        this.averageSeasons.map(eas => {
          //If season doesn't exist in dataFiltered, then add
          if(!dataFiltered.some(s => eas.seasonId == s.seasonId)){
            dataFiltered.push(eas);
          }
        });
        
        //2.- Filter seasons only regular (UEFA Youth League 97312) and with less than 5 games played
        if(this.isFedVenezuela){
          dataFiltered = dataFiltered.filter(s=> s.hasAverage);
        }else{
          dataFiltered = dataFiltered.filter(s=> (s.regular || s.leagueId == 97312) && s.hasAverage);
        }
        
        //3.- Filter seasons
        if(this.templateActive && this.templateActive.cPD){
          //3.1.- If Physical Radar is selected, filter to show only seasons with physical data available
          dataFiltered = dataFiltered.filter(s=> s.hasPhysicalData);
        }
        if(this.templateActive && this.templateActive.cA){
          //3.2.- If Arrigo Radar is selected, filter to show only seasons with arrigo data available
          dataFiltered = dataFiltered.filter(s=> s.hasArrigoData);
        }
        
        //4.- Sort Desc by year, regular and elo
        dataFiltered.sort((a,b) => {
          //Compare first by year, if equals, compare by regular
          if (b.year !== a.year) {
            return b.year - a.year; 
          }
          // If equals by regular
          if (b.regular !== a.regular) {
            return b.regular - a.regular;
          }
          //Then compare by elo
          return b.elo - a.elo;
        });

        //5.- Set default season to the first place
        if(this.player.currentTeamSeasonId){
          // Step 2: Find the element to move (e.g., an element where year === 2024)
          const seasonToMove = dataFiltered.find(el => el.seasonId === this.player.currentTeamSeasonId);
          // Step 3: Remove the element from its current position
          if (seasonToMove) {
              dataFiltered = dataFiltered.filter(el => el.seasonId !== seasonToMove.seasonId);
              // Step 4: Add the element to the beginning of the array
              dataFiltered.unshift(seasonToMove);
          }
        }

        return dataFiltered;

      }else{
        return this.playerSeasonData;
      }
    },
    comparePlayerSeasonsPlayed(){
      if(this.templateActive){
        this.comparePlayerSeasonData.forEach(season => {
          //Disable season if: 
          //      selected template has Physical Stats & season has no PD
          //      selected template has Arrigo Stats & season has no Arrigo Data
          season.disabled = (this.templateActive.cPD && !season.hasPhysicalData) || 
                            (this.templateActive.cA && !season.hasArrigoData);
        });
      }
      return this.comparePlayerSeasonData;
    },
    comparePlayerSeasonDataFiltered() {
      let dataFiltered = _.cloneDeep(this.comparePlayerSeasonsPlayed);
      if(this.templateActive){
        dataFiltered = dataFiltered.filter(s=> this.templateActive.cXY || 
                                            (this.templateActive.cPD && s.hasPhysicalData) || 
                                            (this.templateActive.cA && s.hasArrigoData)
                                        );
      }
      return dataFiltered;
    },
    polarData(){
      if(this.radarData && this.positionIdOfTemplateActive > 0){
        let polarData = _.cloneDeep(this.radarData);
        return polarData;
      }
    },
    hasCustomRadars(){
      return this.currentUser.clientId != 30 && _.some(this.templates,(t) => t.clientId === this.currentUser.clientId)
    },
    team(){
      return {
        teamId: this.headerPlayer.teamId,
        teamName: this.headerPlayer.teamName
      }
    },
    showSeasonsAsCheckbox(){
      return this.minMaxModel !== "selectedSeason";
    },
    lollipopMinMaxLabel(){
      if(this.minMaxModel === "top5Leagues"){
        return this.$t("playerRecruitment.top5Leagues");
      }else if(this.minMaxModel === "selectedSeason"){
        return this.radarTitle.split(" · ")[1];
      }else if(this.minMaxModel === 'ownSeason'){
        return this.$t(`playerRecruitment.ownSeason`);
      }else if(this.minMaxModel === 'champions'){
        return "A+/A";
      }else if(this.minMaxModel === 'europa'){
        return "B+";
      }else if(this.minMaxModel === 'ligaMX'){
        return "Liga MX";
      }else if(this.minMaxModel === 'segundaDivision'){
        return "Segunda División";
      }else if(this.minMaxModel === 'atmAcademyMinMax'){
        return "ATM Academia";
      }

      return ""
    },
    currentUserSeasonId(){
      let teamSeasonId = _.get(this.currentUser,'team.seasonId');
      let leagueSeasonId = _.get(this.currentUser,'league.seasonId');
      if(teamSeasonId || leagueSeasonId){
        return teamSeasonId ? teamSeasonId : leagueSeasonId
      }
      return null;
    },
    tourSteps(){
      let steps = [
        {
          target: `#player-base-info`,
          header: {
            title: this.$t("tours.playerRadar.step1.title"),
          },
          content: this.$t("tours.playerRadar.step1.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: "#player-gbe",
          header: {
            title: this.$t("tours.playerRadar.step2.title"),
          },
          content: this.$t("tours.playerRadar.step2.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: "#player-availability",
          header: {
            title: this.$t("tours.playerRadar.step3.title"),
          },
          content: this.$t("tours.playerRadar.step3.message"),
          params: {
            placement: "bottom",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: "#player-position-chart",
          header: {
            title: this.$t("tours.playerRadar.step4.title"),
          },
          content: this.$t("tours.playerRadar.step4.message"),
          params: {
            placement: "bottom",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#player-chart-selector`,
          header: {
            title: this.$t("tours.playerRadar.step5.title"),
          },
          content: this.$t("tours.playerRadar.step5.message"),
          params: {
            placement: "bottom",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#chart`,
          header: {
            title: this.$t("tours.playerRadar.step6.title"),
          },
          content: this.$t("tours.playerRadar.step6.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#player-season-selector`,
          header: {
            title: this.$t("tours.playerRadar.step7.title"),
          },
          content: this.$t("tours.playerRadar.step7.message"),
          params: {
            placement: this.$vuetify.breakpoint.smAndDown ? "top" : "right",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#player-radar-selector`,
          header: {
            title: this.$t("tours.playerRadar.step8.title"),
          },
          content: this.$t("tours.playerRadar.step8.message"),
          params: {
            placement: this.$vuetify.breakpoint.smAndDown ? "top" : "right",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#player-position-selector`,
          header: {
            title: this.$t("tours.playerRadar.step9.title"),
          },
          content: this.$t("tours.playerRadar.step9.message"),
          params: {
            placement: this.$vuetify.breakpoint.smAndDown ? "top" : "right",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#player-minmax-selector`,
          header: {
            title: this.$t("tours.playerRadar.step10.title"),
          },
          content: this.$t("tours.playerRadar.step10.message"),
          params: {
            placement: this.$vuetify.breakpoint.smAndDown ? "top" : "right",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#player-compare-zone`,
          header: {
            title: this.$t("tours.playerRadar.step11.title"),
          },
          content: this.$t("tours.playerRadar.step11.message"),
          params: {
            placement: this.$vuetify.breakpoint.smAndDown ? "top" : "right",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#player-download-zone`,
          header: {
            title: this.$t("tours.playerRadar.step12.title"),
          },
          content: this.$t("tours.playerRadar.step12.message"),
          params: {
            placement: this.$vuetify.breakpoint.smAndDown ? "top" : "right",
            enableScrolling: false,
            highlight: true
          }
        }
      ];
      //If user has no role EVENTING, remove GBE step
      if(!this.userHasRole("ROLE_EVENTING_DATA")){
        steps = steps.filter(s=> !s.target.includes("player-gbe"));
      }
      return steps;
    },
    isACTalentUser(){
      return this.currentUser.clientId == 10021;
    },
    isOrlegiUser(){
      return this.currentUser.clientId == 10042;
    },
    isATMAcademy(){
      return this.currentUser.clientId == 10860;
    },
    isFedVenezuela(){
      return this.currentUser.clientId == 10023;
    },
    isDLUsers(){
      //aduran, amartinez, jlopez, rcumbraos
      return [21, 10714, 11718, 12961].includes(this.currentUser.id);
    },
    //Check if user has only ROLE_PHYSICAL_DATA (without eventing)
    onlyPhysicalData(){
      return !this.userHasRole("ROLE_EVENTING_DATA") && this.userHasRole("ROLE_PHYSICAL_DATA");
    },
    seasonsWithout60MinsGames(){
      const seasonsSelected = this.playerSeasonData.filter((s) =>
        this.seasonIdsMainPlayerSelected.includes(s.seasonId) ||
        this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}`) || 
        this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}-${s.teamId}`)
      );

      return _.every(seasonsSelected,(s) => s.gamesPlayed60Mins === 0 || !s.gamesPlayed60Mins);
    },
    showRadarIcons() {
      if (!this.radarData || !this.radarData.statDTOs.length) return false;
      const statProductIds = this.radarData.statDTOs[0].map(s => s.productId);
      //Only show if there are different ids
      return _.uniq(statProductIds).length > 1;
    },
    groupedTemplates() {
      if (!this.templates || !this.templates.length) 
        return {};
      const grouped = _.groupBy(this.templates, template => {
        if (template.cXY) return 'ROLE_EVENTING_DATA';
        if (template.cPD) return 'ROLE_PHYSICAL_DATA';
        if (template.cA) return 'ROLE_ARRIGO';
        return 'OTHER';
      });
      const orderedKeys = ['ROLE_EVENTING_DATA', 'ROLE_PHYSICAL_DATA', 'ROLE_ARRIGO', 'OTHER'];
      // Return a new object with keys in desired order
      const orderedGrouped = {};
      for (const key of orderedKeys) {
        if (grouped[key]) {
          orderedGrouped[key] = _.orderBy(grouped[key], ['radarName'], ['asc']);
        }
      }
     
      return orderedGrouped;
    }
  },
  async created() {
    this.loading = true;
    //Load Radar for first time when page load
    this.player = this.headerPlayer;
    await this.loadDataSet();
    await this.loadAverageSeasons();
    await this.loadViewData();
  },
  mounted() {
    this.mediaMode = this.stackedView ? false : (this.currentUser.mediaMode || this.currentUser.clientType === 'Media');
    this.size = this.$refs.chart.clientWidth > 1000 ? 1000 : this.$refs.chart.clientWidth;
    this.language = this.currentUserLanguage;
    this.selectedTab = this.currentUserDefaultVisualization;
    this.margin = {
      top: this.size * 0.13,
      right: this.size * 0.2,
      bottom: 0,
      left: 0,
    };

  },
  methods: {
    async loadViewData() {
      this.yob =
      this.player && this.player.dob
        ? this.player.dob.split("/")[2].substring(2, 4)
        : this.player && this.player.age ? (new Date().getFullYear() - this.player.age).toString().substring(2, 4) : "";

      this.playerSeasonData = _.map(this.headerPlayerSeasonData,(h) => {h.compoundId = `${h.seasonId}-${h.teamId}`;h.compoundText = `${h.seasonName}-${h.teamName}`;return h;});

      //If user has only PHYSICAL_DATA role, then show only seasons with PD
      if(this.onlyPhysicalData){
        this.playerSeasonData = this.playerSeasonData.filter(psd => psd.hasPhysicalData);
      }

      // Default season : Last Regular season of the player's team
      let defaultSeason = this.playerSeasonsPlayed.find(psd => psd.regular && 
                                          psd.teamId === this.player.teamId && 
                                          psd.year === psd.leagueLastYear);

      if(!defaultSeason){
        // If there is no season, take last regular played in other team
        defaultSeason = this.playerSeasonsPlayed.find(psd => psd.regular && 
                                          psd.year === psd.leagueLastYear);
      }

      if(!defaultSeason){
        // If there is no season, take first from all seasons played
        defaultSeason = this.playerSeasonsPlayed[0];
      }

      this.seasonDataSelectedCheckBoxModel = [`${defaultSeason.seasonId}-${defaultSeason.teamId}`];
      this.seasonDataSelectedRadiosModel = this.seasonDataSelectedCheckBoxModel[0];

      this.onSeasonChange(defaultSeason);

      // Split seasons in years
      this.currentYear = this.playerSeasonsPlayed
                             .map((s) => s.year)
                             .reduce((a, b) => (a.year > b.year ? b : a));

      this.playerSeasonDataCurrentYear = this.playerSeasonsPlayed.filter(
        (s) => s.year === this.currentYear
      );
      this.playerSeasonDataLastYear = this.playerSeasonsPlayed.filter(
        (s) => s.year !== this.currentYear
      );

      let responseProfile = await PlayerService.getPlayerProfiles(this.playerId);
      this.playerProfiles = responseProfile.data;

      //When window resize
      window.addEventListener("resize", this.onWindowResize);

      this.mediaModeData.upperText = this.player.name;
      this.mediaModeData.lowerText = this.$t("playerDetail.performance");
      this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
      this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0.png`;
      this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
      this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      if(!this.mediaMode){
        this.mediaModeData.textColor = this.defaultColors.textColor;
        this.mediaModeData.axisColor = this.defaultColors.axisColor;
      }
    },
    async loadDataSet() {
      this.dataSetAllPlayers = await this.$store.dispatch("getDataSet");
    },
    async loadAverageSeasons(){
      //Get all LeagueIds by Client
      let response = await LeagueService.getAllLeaguesByClient(this.currentUser.clientId);
      let resp = await SeasonService.getSeasonsByLeagues(response.data.map(l => l.id), this.currentUser.maxYearsVisible);
      this.averageSeasons = resp.data;
    },
    clearSearchItems(clearAutoCompare = true) {
      this.autoCompareModel = clearAutoCompare ? null : this.autoCompareModel;
      this.clearComparePlayerSection();
      //Clear Compare Player from Radar
      this.radarData = this.mainPlayerRadarData;
      //Clear League Average section
      this.leaguesAverageObjectModel = null;
      //Enable "Selected Season" minMax
      this.seasonMinMaxRadioLollipopDisabled = false;
      this.mediaModeFields = _.filter(this.mediaModeFields,(f) => !f.comparison);
      //Update radar
      this.updateChartsByRef();
      setTimeout(() => this.onWindowResize(null,true),100);
    },
    clearComparePlayerSection(){
      //Empty Compare Player selection
      this.selectedPlayer = null;
      this.comparePlayerData = null;
      this.comparePlayerRadarData = null;
      this.comparePlayerProfiles = null;
      this.searchesLimitReached = false;
      //Empty seasons of Compare Player
      this.comparePlayerSeasonData.length = 0;
      this.comparePlayerSeasonData = [];
      this.comparePlayerSeasonDataCurrentYear.length = 0;
      this.comparePlayerSeasonDataCurrentYear = [];
      this.comparePlayerSeasonDataLastYear.length = 0;
      this.comparePlayerSeasonDataLastYear = [];
      this.shortPositionsPlayedComparePlayer.length = 0;
      this.shortPositionsPlayedComparePlayer = [];
      this.shortPositionsPlayedComparePlayerModel.length = 0;
      this.shortPositionsPlayedComparePlayerModel = [];
      this.seasonDataComparePlayerSelectedCheckBoxModel.length = 0;
      this.seasonDataComparePlayerSelectedCheckBoxModel = [];
    },
    onWindowResize(e, force=false) {
      this.size = this.$refs.chart.clientWidth > 1000 ? 1000 : this.$refs.chart.clientWidth;;

      this.margin = {
        top: this.size * 0.13,
        right: this.size * 0.2,
        bottom: 0,
        left: 0,
      };

      //If width or height has changed, then redraw Radar
      if(this.prevWindowWidth != document.documentElement.clientWidth ||
        this.prevWindowHeight != document.documentElement.clientHeight){
          this.prevWindowWidth = document.documentElement.clientWidth;
          this.prevWindowHeight = document.documentElement.clientHeight;
          this.updateChartsByRef(force);
          this.$forceUpdate();
      }

    },
    minMaxChange() {
      if (this.showSeasonsAsCheckbox) {
        //If there is no autocomplete
        if(!this.showAutocomplete){
          this.seasonDataSelectedCheckBoxModel.length = 0;
          this.seasonDataSelectedCheckBoxModel.push(
            this.seasonDataSelectedRadiosModel
          );
        }
        //On MinMax change, if Compare Player is selected, reset seasons checks and radios
        if (this.comparePlayerData) {
          this.seasonDataComparePlayerSelectedCheckBoxModel.length = 0;
          this.seasonDataComparePlayerSelectedCheckBoxModel.push(
            this.seasonDataComparePlayerSelectedRadiosModel
          );
        }
      } else {
        //If there is no autocomplete
        if(!this.showAutocomplete)
          this.seasonDataSelectedRadiosModel = this.seasonDataSelectedCheckBoxModel[0];
        //On MinMax change, if Compare Player is selected, reset seasons checks and radios
        if (this.comparePlayerData) {
          this.seasonDataComparePlayerSelectedRadiosModel = this.seasonDataComparePlayerSelectedCheckBoxModel[0];
        }
      }

      this.renderRadar();
      if (this.comparePlayerData) {
        //If league average is selected, then render compare player as average of league
        if(this.leaguesAverageObjectModel)
          this.onLeagueAverageChange(this.leaguesAverageObjectModel);
        else
          //If league average is null, then render compare player
          this.renderComparisonRadar();
      }
      if(this.autoCompareModel != null){
        this.onAutoCompareChange();
      }
    },
    async getPositionsPlayedOfPlayer(seasonData) {
      if (this.seasonDataSelectedCheckBoxModel.length === 0) {
        //Doesn't allow uncheck all checkbox. If selected seasons = 0, then check the season again
        this.seasonDataSelectedCheckBoxModel = [`${seasonData.seasonId}-${seasonData.teamId}`];
      }

      //Get season ids from checkbox or from radio buttons
      let seasonIdsSelected = this.showSeasonsAsCheckbox
      ? this.seasonDataSelectedCheckBoxModel : [this.seasonDataSelectedRadiosModel];

      const seasonsSelected = this.playerSeasonData.filter((s) => seasonIdsSelected.includes(`${s.seasonId}-${s.teamId}`));

      //Get positions played
      let [positionsData, shortPositionsData] = await Promise.all([
        PlayerService.getPositionsPlayedOfPlayer(
          this.playerId,
          Array.from(new Set(seasonsSelected.map((s) => s.teamId))),
          _.map(seasonIdsSelected,(s) => _.split(s,'-')[0])
        ),
        PlayerService.getShortPositionsPlayedOfPlayer(
          this.playerId,
          Array.from(new Set(seasonsSelected.map((s) => s.teamId))),
          _.map(seasonIdsSelected,(s) => _.split(s,'-')[0])
        ),
      ]);

      //Positions Played used in getRadarTemplates method
      this.positionsPlayed = positionsData.data.filter(
        (p) => p.minutesPlayed != 0
      );
      this.shortPositionsPlayed = shortPositionsData.data;
      this.shortPositionsPlayedModel = shortPositionsData.data.map(
        (p) => p.position
      );
      await this.getRadarTemplates();
    },
    renderRadar() {
      //Need to set timeout on physical radar to get physical minutes played from back
      let timeOut = this.templateActive && this.templateActive.cPD ? 700 : 0;
      clearTimeout(this.mainPlayerTimeOut);
      this.mainPlayerTimeOut = setTimeout(async () => {
        //Get Ids from checkbox or radio button
        this.seasonIdsMainPlayerSelected = this.showSeasonsAsCheckbox
          ? this.seasonDataSelectedCheckBoxModel
          : [this.seasonDataSelectedRadiosModel];

        const seasonsSelected = this.playerSeasonData.filter((s) =>
          this.seasonIdsMainPlayerSelected.includes(s.seasonId) ||
          this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}`) || 
          this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}-${s.teamId}`)
        );

        if(seasonsSelected.length === 1){
          this.seasonSelectedMainPlayerMoreThan5GamesPlayed = seasonsSelected[0].gamesPlayed > 5 ? true : false;
        }

        this.seasonMinMaxRadioDisabled =
          this.seasonDataSelectedCheckBoxModel.length > 1 ||
          this.seasonDataComparePlayerSelectedCheckBoxModel.length > 1
            ? true
            : false;
        //Get Year of the season with more minutesPlayed
        this.seasonMoreMinutesPlayedYear =
          seasonsSelected.length > 1
            ? seasonsSelected.reduce(
                (max, season) =>
                  season.minutesPlayed > max ? season.year : max,
                seasonsSelected[0].minutesPlayed
              )
            : seasonsSelected[0].year;
        //Get League Id of the season with more minutesPlayed
        this.leagueIdWithMoreMinutesPlayed =
          seasonsSelected.length > 1
            ? seasonsSelected.reduce(
                (max, season) =>
                  season.minutesPlayed > max ? season.leagueId : max,
                seasonsSelected[0].minutesPlayed
              )
            : seasonsSelected[0].leagueId;

        this.leagueLabelWithMoreMinutesPlayed =
          seasonsSelected.length > 1
            ? seasonsSelected.reduce(
                (max, season) =>
                  season.minutesPlayed >= max
                    ? season.seasonName.replace(" 20", " '")
                    : max,
                seasonsSelected[0].minutesPlayed
              )
            : seasonsSelected[0].seasonName.replace(" 20", " '");

        //Generate Radar Title
        this.radarTitle = _.reduce(
          seasonsSelected,
          (accum, s, index) => {
            accum += accum.includes(s.teamName)
              ? s.seasonName.replace(" 20", " '")
              : s.teamName + " · " + s.seasonName.replace(" 20", " '");
            accum += index === seasonsSelected.length - 1 ? "" : ", ";
            return accum;
          },
          ""
        );

        this.radarTitle =
          this.radarTitle.length > 100
            ? this.radarTitle.substring(0, 100) + ". . ."
            : this.radarTitle;

        if(!this.templateActiveId){
          let templateActiveObject = this.getDefaultTemplate();
          this.positionIdOfTemplateActive = templateActiveObject.positionId;
          //If template has changed, clear compare player
          if(this.templateActiveId !== templateActiveObject.radarId){
            this.clearSearchItems();
          }
          this.templateActiveId = templateActiveObject.radarId;

          this.templates = [...this.templates];
          this.$forceUpdate();
        }
        //let selectedTemplate = this.templates.filter(t => t.radarId === this.templateActiveId)[0];
        let radarId = this.templateActive.radarId ? this.templateActive.radarId : 0;
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const browser = navigator.userAgent;
        const url = this.$route.path;
        let metaInfo = null;


        let allPositions = _.every(this.shortPositionsPlayed,(p) => _.includes(this.shortPositionsPlayedModel,p.position));
        let shortPositionsIdsSelected = Array.from(new Set(this.shortPositionsPlayed
                                .filter(p => this.shortPositionsPlayedModel.includes(p.position))
                                .map(p => p.fieldPositionId)));
        //Check if there is a compare Player selected
        if(this.selectedPlayer){
          let allComparePositions = _.every(this.shortPositionsPlayedComparePlayer,(p) => _.includes(this.shortPositionsPlayedComparePlayerModel,p.position));
          let compareShortPositionsIdsSelected = Array.from(new Set(this.shortPositionsPlayedComparePlayer
                                  .filter(p => this.shortPositionsPlayedComparePlayerModel.includes(p.position))
                                  .map(p => p.fieldPositionId)));

          metaInfo = JSON.stringify({
             playerId: this.playerId,
             playerName: this.player.name,
             comparePlayerId: this.selectedPlayer.playerId,
             comparePlayerName: this.selectedPlayer.name
          });

          //Add short positions of Compare Player if all are not selected
          if(!allComparePositions){
            metaInfo = metaInfo ? JSON.parse(metaInfo) : {};
            metaInfo = JSON.stringify({...metaInfo, comparePositionIds: compareShortPositionsIdsSelected.toString()});
          }

        }
        //Check if there is an average season
        if(this.leaguesAverageObjectModel){
          //League Average Compare
          metaInfo = JSON.stringify({
             playerId: this.playerId,
             playerName: this.player.name,
             compareSeasonId: this.leaguesAverageObjectModel.seasonId,
             compareSeasonName: this.leaguesAverageObjectModel.seasonName,
             templatePositionId: this.templateActive.positionId,
             isAverage: true
          });
        }

        //Check autoCompare
        if(this.autoCompareModel != null && this.autoCompareModel != -1){
          metaInfo = JSON.stringify({
             playerId: this.playerId,
             playerName: this.player.name,
             comparePlayerId: this.playerId,
             comparePlayerName: this.player.name,
             games: this.autoCompareModel,
             templatePositionId: this.templateActive.positionId
          });
        }

        //If not all positions checked, then add positions selected to metaInfo
        if(!allPositions){
          metaInfo = metaInfo ? JSON.parse(metaInfo) : {};
          metaInfo = JSON.stringify({positionIds: shortPositionsIdsSelected.toString(), ...metaInfo});
        }

        //Set impostor metaInfo if user is an impostor
        if(this.currentUser.impostor){
          metaInfo = metaInfo ? JSON.parse(metaInfo) : {};
          metaInfo = JSON.stringify({impostor: this.currentUser.impostor, impostorName: this.$store.getters['auth/impostor'].username, ...metaInfo});
        }

        let minMaxSeasonToGet = _.first(seasonsSelected.map((s) => s.seasonId))
        if (this.minMaxModel === "ownSeason")
          minMaxSeasonToGet = this.currentUserSeasonId
        if (this.minMaxModel === 'champions')
          minMaxSeasonToGet = 9
        if (this.minMaxModel === 'europa')
          minMaxSeasonToGet = 10
        if (this.minMaxModel === 'ligaMX')
          minMaxSeasonToGet = 13
        if (this.minMaxModel === 'segundaDivision')
          minMaxSeasonToGet = 14
        if (this.minMaxModel === 'atmAcademyMinMax')
          minMaxSeasonToGet = 16


        let response = await PlayerRadarService.getRadarData(
          this.playerId,
          [...new Set(seasonsSelected.map((s) => s.teamId))],//Remove duplicates teamIds
          [...new Set(seasonsSelected.map((s) => s.seasonId))],//Remove duplicates seasonIds
          shortPositionsIdsSelected,
          this.templateActive.positionId,
          //Mark top5Leagues as true for back only when first radio selected
          this.minMaxModel === "top5Leagues",
          minMaxSeasonToGet,
          this.currentUser.clientId,
          radarId,
          allPositions,
          this.selectedTab === "radar",
          this.allGamesModel,
          url,
          timeZone,
          browser,
          metaInfo);

          this.mainPlayerRadarData = response.data;
          //If Compare Player Radar exists, concat radares
          if (this.comparePlayerRadarData) {
            let data = this.mainPlayerRadarData.statDTOs.concat(
              this.comparePlayerRadarData.statDTOs
            );
            this.radarData = { statDTOs: data,
                               minutesPlayed: this.mainPlayerRadarData.minutesPlayed,
                               radarPosition: this.mainPlayerRadarData.radarPosition,
                               numberOfPlayers: this.mainPlayerRadarData.numberOfPlayers
                             };
          } else {
            this.radarData = response.data;
          }

          //If render physical or arrigo radar...
          if(this.templateActive.cPD || this.templateActive.cA){
            //...then overwrite minsPlayed with physical minutes played
            this.radarData.minutesPlayed = this.mainPlayerRadarData.minsPlayedPD;
          }

          this.updateChartsByRef();

          setTimeout(() => {
            this.loading = false
          },1);

      }, timeOut);

    },
    filterPlayers(shortPositionsToFilter) {
      if (shortPositionsToFilter && shortPositionsToFilter.length > 0 && this.dataSetAllPlayers && !(this.isATMAcademy || this.isACTalentUser || this.isDLUsers)) {
        this.dataSetFiltered = Object.freeze({
          players: _.filter(this.dataSetAllPlayers.players, (item) => {
            const cPD = _.get(this, 'templateActive.cPD', false);
            const cA = _.get(this, 'templateActive.cA', false);

            const positionMatch = _.includes(shortPositionsToFilter, item.pos) || _.includes(shortPositionsToFilter, item.pos2);
            const pdMatch = !cPD || (cPD && item.pd === true);
            const arrMatch = !cA || (cA && item.arr === true);

            return positionMatch && pdMatch && arrMatch;
          }),
        });
        
        //If a player is selected on Compare Player
        if(this.selectedPlayer){
          //If not exists in the new filtered list, then remove it
          if(!this.dataSetFiltered.players.find(p => p.playerId == this.selectedPlayer.playerId)){
            this.clearComparePlayerSection();
          }
        }

      } else {
        this.dataSetFiltered = this.dataSetAllPlayers;
      }
    },
    /* When Template Radio Button change */
    async onTemplateChange() {
      //Try to find sleected season after filter seasons
      let defaultSeason = this.playerSeasonDataFiltered.find(ps => `${ps.seasonId}-${ps.teamId}` === this.seasonDataSelectedCheckBoxModel[0]);
      if(!defaultSeason){
        //If not exist, take first
        defaultSeason = this.playerSeasonDataFiltered[0];
        this.seasonDataSelectedCheckBoxModel = [`${defaultSeason.seasonId}-${defaultSeason.teamId}`];
        this.seasonDataSelectedRadiosModel = this.seasonDataSelectedCheckBoxModel[0];
      }
       
      if(this.selectedTab === "polar")
        this.loading = true;

      this.positionIdOfTemplateActive = this.templateActive ? this.templateActive.positionId : 0; 
      
      let shortPositionsByTemplateActive = getShortPositionsByTemplate(
        this.positionIdOfTemplateActive, false
      );

      if(shortPositionsByTemplateActive){
        //Filter players in Search Bar by Template shorts positions
        await this.filterPlayersIfAvailable(shortPositionsByTemplateActive);
      }
      //Render main player radar
      this.renderRadar();
      //If still exists player selected, then render comparison radar
      if(this.selectedPlayer)
        this.renderComparisonRadar();
    },
    filterPlayersIfAvailable(shortPositionsByTemplateActive) {
      const poll = resolve => {
        if (this.dataSetAllPlayers) {
          this.filterPlayers(shortPositionsByTemplateActive)
          resolve();
        } else {
          // Data is not going to load, fill dataset again
          this.loadDataSet();
          setTimeout(_ => poll(resolve), 250);
        }
      }
      return new Promise(poll);
    },
    async getRadarTemplates(){
      //ids from dim_category for arrigo and physical categories
      const physicalCategoryId = 17;
      const arrigoCategoryId = 26;

      let positionIds = this.positionsPlayed.map((p) => p.positionId);
      if(this.isATMAcademy){
        //If contains Fullback(3) or WingBack(7), add positions 3 and 7
        if(positionIds.includes(3) || positionIds.includes(7)){
          positionIds.push(3);
          positionIds.push(7);
        }
      }
      //Remove duplicates
      positionIds = [...new Set(positionIds)];
      let response = await PlayerRadarService.getRadarTemplatesByPositionsAndClientId(positionIds);
      
      let driblabRadars = _.filter(response.data, r => {
        //18 - Predictive
        return (r.clientId === 0 && [0,18].includes(r.categoryId));
      });

      //Get all driblab physical radars, just for users that have ROLE_PHYSICAL_DATA
      let driblabPDRadars = this.showPhysicalTemplates ? _.filter(response.data, r => {
        return r.clientId === 0 && physicalCategoryId == r.categoryId;
      }) : [];

      //Get all arrigo radars, just for users that have ROLE_ARRIGO
      let driblabArrigoRadars = this.showArrigoTemplates ? _.filter(response.data, r => {
        return r.clientId === 0 && arrigoCategoryId == r.categoryId;
      }) : [];

      //Get client radars, without physical
      let clientRadars = _.filter(response.data, r => {
        return r.clientId === this.currentUser.clientId;
      });

      let mediaRadars = _.filter(response.data, r => {
        return (r.categoryId === 38 && ((this.currentUser.clientType === 'Driblab') || this.currentUser.clientType === 'Media'));
      });

      let minutesAccum = _.reduce(
        this.positionsPlayed,
        (accum, p) => {
          let template = p.position;
          if (!accum[template]) {
            accum[template] = {};
          }
          accum[template] = { positionId: p.positionId, mins: p.minutesPlayed };
          return accum;
        },
        {}
      );

      let finalRadars;
      if (this.userHasRole('ROLE_ADMIN')) {
        if (_.size(clientRadars) > 0)
          finalRadars = [...clientRadars,...driblabRadars];
        else
          finalRadars = [...driblabRadars];
      } else {
        finalRadars = _.size(clientRadars) > 0 ? [...clientRadars,...driblabRadars] : [...driblabRadars];
      };

      let radarsAllowed = _.concat(finalRadars, mediaRadars, driblabPDRadars, driblabArrigoRadars);
      //If user has only physical radars
      if(this.onlyPhysicalData){
        //If only can see Physical Data, show Driblab Physical templates and radars that contains at least one physical stat
        radarsAllowed = _.concat(driblabPDRadars, clientRadars.filter(r => r.cPD));
      }

      let publicRadars = radarsAllowed.filter(r => r.visibilityId === 1);
      let privateRadars = radarsAllowed.filter(r => r.visibilityId === 2 && r.createdByUserId === this.currentUser.id);
      let supervisedRadars = getSupervisedItems(radarsAllowed.filter(r => r.visibilityId === 3), this.currentUser.userType, this.currentUser.id);

      radarsAllowed = [...publicRadars,...privateRadars,...supervisedRadars];
     
      this.templates = _.chain(radarsAllowed)
        .filter(r => r.visible)
        .map((value, key) => {
          let mins = _.reduce(minutesAccum,(accum,ma) => ma.positionId === value.positionId ? accum + ma.mins : accum,0);
          return {
            radarId: value.radarId,
            positionId: value.positionId,
            position: value.position,
            categoryId: value.categoryId,
            minutesPlayed: mins,
            isMedia: _.includes(value.code,"Media") && this.mediaMode,
            template: value.code,
            code: value.code,
            clientId: value.clientId,
            defaultRadar: value.defaultRadar,
            radarName: value.radarName,
            //Contains Eventing stats
            cXY: value.cXY,
            //Contains Physical stats
            cPD: value.cPD,
            //Contains Arrigo stats
            cA: value.cA
          };
        })
        .uniq()
        .orderBy(["minutesPlayed","isMedia"],["desc","desc"])
        .value();

      let templateActiveObject = this.getDefaultTemplate();
      this.positionIdOfTemplateActive = templateActiveObject.positionId;
      //If template has changed, clear compare player
      if(this.templateActiveId !== templateActiveObject.radarId){
        this.clearSearchItems();
      }

      this.templateActiveId = templateActiveObject.radarId;
      
      let shortPositionsByTemplateActive = getShortPositionsByTemplate(
        this.positionIdOfTemplateActive, false
      );
      //Filter players in Search Bar by Template shorts positions
      await this.filterPlayersIfAvailable(shortPositionsByTemplateActive);
    },
    /* ------------- PLAYER COMPARISON METHODS ----------------- */
    async onResultClicked(result, clearAutoCompare = true) {
      this.autoCompareModel = clearAutoCompare ? null : this.autoCompareModel;
      this.leaguesAverageObjectModel = null;
      this.selectedPlayer = result.value;

      //Get Profiles of Compare Player
      PlayerService.getPlayerProfiles(this.selectedPlayer.playerId).then((response) => {
        this.comparePlayerProfiles = response.data;
      });
      //Clear Previous Seasons Selections
      this.seasonDataComparePlayerSelectedCheckBoxModel.length = 0;
      this.seasonDataComparePlayerSelectedCheckBoxModel = [];
      Promise.all([
        PlayerService.getPlayerTeamSeasonData(
          this.selectedPlayer.playerId,
          this.currentUser.clientId
        ),
      ]).then(([seasonsData]) => {
        this.comparePlayerSeasonData = _.map(seasonsData.data,(h) => {h.compoundId = `${h.seasonId}-${h.teamId}`;h.compoundText = `${h.seasonName}-${h.teamName}`;return h;});
        let defaultSeason;
        //if physical radar is selected, filter compare payer seasons to show just seasons with physical data
        if(this.templateActive && this.templateActive.cPD){
          defaultSeason = this.comparePlayerSeasonDataFiltered[0];
        }else{
          // Default season : Regular season order by last match date desc
          defaultSeason = _.chain(this.comparePlayerSeasonData).filter(psd => psd.regular).map(psd => {
            psd.time = moment(psd.lastMatchDate,"DD/MM/YYYY").unix();
            return psd;
          }).orderBy("time","desc").value();
          //-1 means 'Last Season' radio selected, so get last regular season [1]. If not, get current regular season [0]
          defaultSeason = defaultSeason[this.autoCompareModel == -1 ? 1 : 0];

          if(!defaultSeason){
            defaultSeason = _.first(this.comparePlayerSeasonData);
          }

        }

        if(defaultSeason){
          this.seasonDataComparePlayerSelectedCheckBoxModel.push(
            `${defaultSeason.seasonId}-${defaultSeason.teamId}`
          );

          this.seasonDataComparePlayerSelectedRadiosModel = `${defaultSeason.seasonId}-${defaultSeason.teamId}`;
        }

        this.comparePlayerSeasonDataCurrentYear = this.comparePlayerSeasonData.filter(
          (s) => s.year === this.currentYear
        );
        this.comparePlayerSeasonDataLastYear = this.comparePlayerSeasonData.filter(
          (s) => s.year !== this.currentYear
        );

        this.enableDisableSelectedSeasonMinMax();

        this.comparePlayerYob =
          this.selectedPlayer && this.selectedPlayer.dob
            ? this.selectedPlayer.dob.split("/")[2].substring(2, 4)
            : this.selectedPlayer && this.selectedPlayer.age ? (new Date().getFullYear() - this.selectedPlayer.age).toString().substring(2, 4) : "";

        this.getPositionsPlayedOfComparisonPlayer().then(() =>
          this.renderComparisonRadar()
        );

        this.mediaModeFields = _.concat(this.mediaModeFields,[{type:"text",label:"mediaMode.comparisonUpperText",key:"comparisonUpperText",comparison:true},
        {type:"text",label:"mediaMode.comparisonLowerText",key:"comparisonLowerText",comparison:true},
        {type:"color",label:"mediaMode.comparisonBorderColor",key:"comparisonBorderColor",comparison:true},
        {type:"color",label:"mediaMode.comparisonFillColor",key:"comparisonFillColor",comparison:true},
        {type:"image",label:"mediaMode.comparisonFace",key:"comparisonFace",comparison:true}]);

      });

    },
    async getPositionsPlayedOfComparisonPlayer(seasonData) {
      if (this.seasonDataComparePlayerSelectedCheckBoxModel.length === 0 && seasonData) {
        //Doesn't allow uncheck all checkbox. If selected seasons = 0, then check the season again
        this.seasonDataComparePlayerSelectedCheckBoxModel = [`${seasonData.seasonId}-${seasonData.teamId}`];
      }

      //Get season ids from checkbox or from radio buttons
      let seasonIdsSelected = this.showSeasonsAsCheckbox
      ? this.seasonDataComparePlayerSelectedCheckBoxModel : [this.seasonDataComparePlayerSelectedRadiosModel];

      const seasonsSelected = this.comparePlayerSeasonData.filter((s) =>
        seasonIdsSelected.includes(`${s.seasonId}-${s.teamId}`)
      );

      //Get positions played
      let shortPositionsData = await PlayerService.getShortPositionsPlayedOfPlayer(this.selectedPlayer.playerId, 
                                                      Array.from(new Set(seasonsSelected.map((s) => s.teamId))), 
                                                      _.map(seasonIdsSelected,(s) => _.split(s,'-')[0])
                                                     );

      this.shortPositionsPlayedComparePlayer = shortPositionsData.data;
      this.shortPositionsPlayedComparePlayerModel = shortPositionsData.data.map(
        (p) => p.position
      );
    },
    saveAsPNG() {
      //selectedTab values -> (radar, lollipop, polar)
      let elementId = this.selectedTab + `${this.playerId}-${this.radarId}SVG`;
      let svgTitle = "Driblab_" + capitalizeFirstLetter(this.selectedTab) + "_" + this.player.name.replace(" ", "_") + "_" + this.radarTitle.replace(" ", "_") + ".png";
      let isLollipopChart = this.selectedTab === "lollipop";
      if(this.mediaMode){
        downloadPng(this.prepareSvgForMedia(elementId, isLollipopChart), svgTitle);
      }else{
        downloadPng(document.getElementById(elementId, isLollipopChart), svgTitle);
      }
    },
    saveAsSVG() {
      let svgTitle = "Driblab_" + capitalizeFirstLetter(this.selectedTab) + "_" + this.player.name.replace(" ", "_") + "_" + this.radarTitle.replace(" ", "_");
      let url = exportSvg(this.getElementToExport(), svgTitle);
    },
    getElementToExport(){
      //selectedTab values -> (radar, lollipop, polar)
      let elementId = `${this.selectedTab}${this.playerId}-${this.radarId}SVG`;
      let isLollipopChart = this.selectedTab === "lollipop";
      if(this.mediaMode){
        return this.prepareSvgForMedia(elementId, isLollipopChart)
      }else{
       return document.getElementById(elementId, isLollipopChart);
      }
    },
    async renderComparisonRadar() {
      //Need to set timeout on physical radar to get physical minutes played from back
      let timeOut = this.templateActive && this.templateActive.cPD ? 700 : 0;
      clearTimeout(this.comparisonPlayerTimeOut);
      this.comparisonPlayerTimeOut = setTimeout(async () => {
        //Get Ids from checkbox or radio button
        this.seasonIdsComparePlayerSelected = this.showSeasonsAsCheckbox
          ? this.seasonDataComparePlayerSelectedCheckBoxModel
          : [this.seasonDataComparePlayerSelectedRadiosModel];

        const seasonsSelected = this.comparePlayerSeasonData.filter((s) =>
          this.seasonIdsComparePlayerSelected.includes(`${s.seasonId}`) || this.seasonIdsComparePlayerSelected.includes(`${s.seasonId}-${s.teamId}`)
        );
        this.seasonMinMaxRadioDisabled =
          this.seasonDataComparePlayerSelectedCheckBoxModel.length > 1 ||
          this.seasonDataSelectedCheckBoxModel.length > 1
            ? true
            : false;

        let compareRadarTitle = _.reduce(
          seasonsSelected,
          (accum, s, index) => {
            accum += accum.includes(s.teamName)
              ? s.seasonName.replace(" 20", " '")
              : s.teamName + " · " + s.seasonName.replace(" 20", " '");
            accum += index === seasonsSelected.length - 1 ? "" : ", ";
            return accum;
          },
          ""
        );

        //Get Year of the season with more minutesPlayed
        this.seasonMoreMinutesPlayedComparePlayerYear =
          seasonsSelected.length > 1
            ? seasonsSelected.reduce(
                (max, season) =>
                  season.minutesPlayed > max ? season.year : max,
                seasonsSelected[0].minutesPlayed
              )
            : seasonsSelected[0].year;
        //Get League Id of the season with more minutesPlayed
        this.leagueIdWithMoreMinutesPlayedComparePlayer =
          seasonsSelected.length > 1
            ? seasonsSelected.reduce(
                (max, season) =>
                  season.minutesPlayed > max ? season.leagueId : max,
                seasonsSelected[0].minutesPlayed
              )
            : seasonsSelected[0].leagueId;

        this.leagueLabelWithMoreMinutesPlayedComparePlayer =
          seasonsSelected.length > 1
            ? seasonsSelected.reduce(
                (max, season) =>
                  season.minutesPlayed > max
                    ? season.seasonName.replace(" 20", " '")
                    : max,
                seasonsSelected[0].minutesPlayed
              )
            : seasonsSelected[0].seasonName.replace(" 20", " '");

        //Calculate compare player radar title
        compareRadarTitle =
          compareRadarTitle.length > 50
            ? compareRadarTitle.substring(0, 50) + ". . ."
            : compareRadarTitle;
        //Update main player radar title
        this.radarTitle =
          this.radarTitle.length > 50
            ? this.radarTitle.substring(0, 50) + ". . ."
            : this.radarTitle;
        //Get minutes played of Compare Player
        this.comparePlayerMinsPlayed = this.shortPositionsPlayedComparePlayer
          .filter((sp) =>
            this.shortPositionsPlayedComparePlayerModel.includes(sp.position)
          )
          .map((d) => d.minutesPlayed)
          .reduce((a, b) => a + b, 0);

        this.comparePlayerData = {
          teamName: this.selectedPlayer.tName,
          playerName: this.selectedPlayer.name,
          seasonsName: compareRadarTitle,
          yob: this.comparePlayerYob,
          minsPlayed: this.comparePlayerMinsPlayed,
          teamId: this.selectedPlayer.tId,
          playerId: this.selectedPlayer.playerId
        };

        this.mediaModeData.comparisonUpperText = this.comparePlayerData.playerName;
        this.mediaModeData.comparisonLowerText = this.$t("playerDetail.performance");
        this.mediaModeData.comparisonFace.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.selectedPlayer.playerId}.png`;
        this.mediaModeData.comparisonFace.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0.png`;


        //let selectedTemplate = this.templates.filter(t => t.radarId === this.templateActiveId)[0];
        let radarId = this.templateActive.radarId ? this.templateActive.radarId : 0;
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const browser = navigator.userAgent;
        const url = this.$route.path;
        let metaInfo = JSON.stringify({
           playerId: this.playerId,
           playerName: this.player.name,
           comparePlayerId: this.selectedPlayer.playerId,
           comparePlayerName: this.selectedPlayer.name
        });
        //Main Player
        let allPositions = _.every(this.shortPositionsPlayed,(p) => _.includes(this.shortPositionsPlayedModel,p.position));
        let shortPositionsIdsSelected = Array.from(new Set(this.shortPositionsPlayed
                                .filter(p => this.shortPositionsPlayedModel.includes(p.position))
                                .map(p => p.fieldPositionId)));
        //If not all positions checked, then add position Ids selected to metaInfo
        if(!allPositions){
          metaInfo = JSON.stringify({positionIds: shortPositionsIdsSelected.toString(), ...JSON.parse(metaInfo)});
        }

        //Compare Player
        let allComparePositions = _.every(this.shortPositionsPlayedComparePlayer,(p) => _.includes(this.shortPositionsPlayedComparePlayerModel,p.position));
        let compareShortPositionsIdsSelected = Array.from(new Set(this.shortPositionsPlayedComparePlayer
                                .filter(p => this.shortPositionsPlayedComparePlayerModel.includes(p.position))
                                .map(p => p.fieldPositionId)));

        //Add short position Ids of Compare Player if all are not selected
        if(!allComparePositions){
          metaInfo = JSON.stringify({...JSON.parse(metaInfo), comparePositionIds: compareShortPositionsIdsSelected.toString()});
        }

        //Set impostor metaInfo if user is an impostor
        if(this.currentUser.impostor){
          metaInfo = JSON.stringify({impostor: this.currentUser.impostor, impostorName: this.$store.getters['auth/impostor'].username, ...JSON.parse(metaInfo)});
        }

        let minMaxSeasonToGet = _.first(seasonsSelected.map((s) => s.seasonId))
        if (this.minMaxModel === "ownSeason")
          minMaxSeasonToGet = this.currentUserSeasonId
        if (this.minMaxModel === 'champions')
          minMaxSeasonToGet = 9
        if (this.minMaxModel === 'europa')
          minMaxSeasonToGet = 10
        if (this.minMaxModel === 'ligaMX')
          minMaxSeasonToGet = 13
        if (this.minMaxModel === 'segundaDivision')
          minMaxSeasonToGet = 14
        if (this.minMaxModel === 'atmAcademyMinMax')
          minMaxSeasonToGet = 16

        let response = await PlayerRadarService.getRadarData(
          this.selectedPlayer.playerId,
          [...new Set(seasonsSelected.map((s) => s.teamId))],//Remove duplicates teamIds
          [...new Set(seasonsSelected.map((s) => s.seasonId))],//Remove duplicates seasonIds
          compareShortPositionsIdsSelected,
          this.templateActive.positionId,
          //Mark top5Leagues as true for back only when first radio selected
          this.minMaxModel === "top5Leagues",
          minMaxSeasonToGet,
          this.currentUser.clientId,
          radarId,
          allComparePositions,
          this.selectedTab === "radar",
          this.allGamesModel,
          url,
          timeZone,
          browser,
          metaInfo
        );

        this.comparePlayerRadarData = response.data;
        //override compare mins with back response
        this.comparePlayerData.minsPlayed = response.data.minutesPlayed;

        //Daily searches limit has been reached with compare player (true) or not (false)
        this.searchesLimitReached = this.comparePlayerRadarData.searchesLimitReached;

        //Concat Radares
        let data = this.mainPlayerRadarData.statDTOs.concat(
          response.data.statDTOs
        );
        this.radarData = { statDTOs: data,
                           minutesPlayed: this.mainPlayerRadarData.minutesPlayed,
                           radarPosition: this.mainPlayerRadarData.radarPosition,
                           numberOfPlayers: this.mainPlayerRadarData.numberOfPlayers
                         };

        //If render physical or arrigo radar...
        if(this.templateActive.cPD || this.templateActive.cA){
          //...then overwrite minsPlayed with physical minutes played
          this.comparePlayerData.minsPlayed = this.comparePlayerRadarData.minsPlayedPD;
          this.radarData.minutesPlayed = this.mainPlayerRadarData.minsPlayedPD;
        }                 
        this.updateChartsByRef();

      }, timeOut);
    },
    onTabChange(tab){
      if(tab === 'radar' || tab === 'lollipop'){
        this.loading = true;
        this.renderRadar();
        if (this.comparePlayerData) {
          this.renderComparisonRadar();
        }
      }else if(tab === 'polar'){
        //There is no compare Polar, so save fac_user_search without compare metaInfo
        this.postSearch(tab);
      }else if(tab === 'performance-text'){
        if(this.autoCompareModel && this.autoCompareModel >= 0)
          this.clearSearchItems();
        //Radar and Lollipop save on fac_user_search on the backend, so just call postSearch if is performance-text
        if(this.selectedPlayer){
          this.enableDisableSelectedSeasonMinMax();
          this.postSearch(tab, this.selectedPlayer.playerId, this.selectedPlayer.name);
        }else{
          this.postSearch(tab);
        }
      }

      if(this.mediaMode){
        this.playerAvatarMediaKey++;
        this.socialMediaKey++;
        this.chartKey++;
      }
    },
    postSearch(tab, comparePlayerId, comparePlayerName){
      const authorized = true;
      let metaInfo = null;
      let category = "player";
      let urlId = this.playerId;
      //If compare player is selected
      if(comparePlayerId && comparePlayerName){
        category += "-comparison";
        metaInfo = JSON.stringify({
          playerId: this.playerId,
          playerName: this.player.name,
          comparePlayerId: comparePlayerId,
          comparePlayerName: comparePlayerName
        });
      }
      const tool = tab;
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;

      UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);

    },
    getPositionChip(position) {
      return getChipColorByPosition(position)
    },
    getPositionsByTemplate() {
      this.positionIdOfTemplateActive = this.templateActive ? this.templateActive.positionId : 0;
      return getShortPositionsByTemplate(this.positionIdOfTemplateActive, false);
    },
    onRadarSizeChange(size){
      this.radarSize = size;
      this.avatarSize = {
        width: size.width,
        height: size.height / 4.75
      }
    },
    prepareSvgForMedia(elementId, isLollipopChart){
      let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
      let heightAccum = 0;
      let x = isLollipopChart ? 20 : 50;
      parent.style.background = this.mediaModeData.bgColor;
      //COPY HEADER
      copyAndAppendElement(parent,document.querySelector(`#playerAvatarMedia${this.playerId}-${this.radarId}SVG`), x, 0)
      heightAccum += this.avatarSize.height;
      copyAndAppendElement(parent,document.querySelector(`#${elementId}`), x, this.avatarSize.height)
      this.radarSize.height += isLollipopChart ? 30 : 0;
      heightAccum += this.radarSize.height;

      if(this.mediaModeData.socialMedia){
        copyAndAppendElement(parent,document.querySelector(`#driblabSocialMedia${this.playerId}-${this.radarId}SVG`), (x - 10), this.avatarSize.height + this.radarSize.height)
        heightAccum += 50;
      }

      parent.setAttribute("width", this.size);
      parent.setAttribute("height", heightAccum);
      return parent;
    },
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
    onMediaModeDataChange(event){
      this.mediaModeData = event;
      this.updateChartsByRef(true);
    },
    onMediaModeChange(event){
      this.mediaMode = event;
      let templateActiveObject = this.getDefaultTemplate();
      this.positionIdOfTemplateActive = templateActiveObject.positionId;
      this.templateActiveId = templateActiveObject.radarId;
      this.onTemplateChange();
    },
    getDefaultTemplate(){
      //1.- Get radar with is_default = true (on dim_radar)
      let defaultTemplates = this.templates.filter(t => {
        //shortPositionsPlayed is sorted by minutes played, so [0] is the position with more minutes played
        return t.positionId === this.shortPositionsPlayed[0].positionId && t.defaultRadar;
      });
      if(!defaultTemplates.length){
        //2.- If there is no default, get predictive radars (categoryId = 18)
        defaultTemplates = this.templates.filter(
          (t) => t.positionId === this.shortPositionsPlayed[0].positionId && t.categoryId === 18
        );
        if(defaultTemplates.length){
          return defaultTemplates[0];
        }else{
          //3.- If there is no Predictive, get Driblab radars (clientId = 0 or categoryId = 0)
          defaultTemplates = this.templates.filter(
            (t) => t.positionId === this.shortPositionsPlayed[0].positionId && !t.clientId
          );
          return defaultTemplates.length ? defaultTemplates[0] : this.templates[0];
        }
      }else{
        //Check if template contains PD or Arrigo and season selected has PD or Arrigo
        if(this.seasonDataSelectedCheckBoxModel.length){
          const seasonsSelected = this.playerSeasonData.filter((s) =>
            this.seasonIdsMainPlayerSelected.includes(s.seasonId) ||
            this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}`) || 
            this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}-${s.teamId}`)
          );
          //If template selected contains PD stats and some season of selected seasons has no physical data, get first template without PD stats
          if(defaultTemplates[0].cPD && seasonsSelected.some(ss => !ss.hasPhysicalData)){
            return this.templates.filter(t => !t.cPD)[0];
          }
          //If template selected contains Arrigo stats and some season of selected seasons has no Arrigo data, get first template without Arrigo stats
          if(defaultTemplates[0].cA && seasonsSelected.some(ss => !ss.hasArrigoData)){
            return this.templates.filter(t => !t.cA)[0];
          }
          
        }
        return defaultTemplates[0];
      }
    },
    async onSeasonChange(seasonData){
      //Get Ids from checkbox or radio button
      this.seasonIdsMainPlayerSelected = this.showSeasonsAsCheckbox
        ? this.seasonDataSelectedCheckBoxModel
        : [this.seasonDataSelectedRadiosModel];
      //Get season object to check if has physical data
      const seasonsSelected = this.playerSeasonData.filter((s) =>
        this.seasonIdsMainPlayerSelected.includes(s.seasonId) ||
        this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}`) || 
        this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}-${s.teamId}`)
      );

      //Check if some season selected has no physical data
      if(seasonsSelected.length){
        this.physicalRadarDisabled = seasonsSelected.some(ss => !ss.hasPhysicalData); 
        this.arrigoRadarDisabled = seasonsSelected.some(ss => !ss.hasArrigoData); 
      }else{
        //If there is no seasons selected, then check current season checked (seasonData)
        this.physicalRadarDisabled = !seasonData.hasPhysicalData;
        this.arrigoRadarDisabled = !seasonData.hasArrigoData;
      }

      this.enableDisableSelectedSeasonMinMax();

      //Just for the first time and Physical radar selected
      if(!(this.templateActive && this.templateActive.cPD)){
        await this.getPositionsPlayedOfPlayer(seasonData);
      }
      
      this.renderRadar();
      if(this.autoCompareModel != null){
        this.onAutoCompareChange();
      }
    },
    async onComparePlayerSeasonChange(seasonData){
      this.enableDisableSelectedSeasonMinMax();
      await this.getPositionsPlayedOfComparisonPlayer(seasonData)
      this.renderComparisonRadar();
    },
    enableDisableSelectedSeasonMinMax(){
      if(this.selectedTab === "lollipop" && this.selectedPlayer){
        //Check if Top 5 Leagues MinMax is selected
        if(this.minMaxModel === "top5Leagues"){
          //Check if seasons of players selected are the same
          this.seasonMinMaxRadioLollipopDisabled = this.seasonDataSelectedCheckBoxModel[0].split("-")[0] == this.seasonDataComparePlayerSelectedCheckBoxModel[0].split("-")[0] ? false : true;
        }else{
          //Selected Season MinMax is selected
          this.seasonMinMaxRadioLollipopDisabled = this.seasonDataSelectedRadiosModel.split("-")[0] == this.seasonDataComparePlayerSelectedRadiosModel.split("-")[0] ? false : true;
          //Set minMax to Top 5 leagues
          if(this.seasonMinMaxRadioLollipopDisabled){
            this.minMaxModel = "top5Leagues";
            this.minMaxChange();
          }
        }
      }else{
        this.seasonMinMaxRadioDisabled =
        this.seasonDataSelectedCheckBoxModel.length > 1 ||
        this.seasonDataComparePlayerSelectedCheckBoxModel.length > 1
          ? true
          : false;
        //Enable "Selected Season" minMax
        this.seasonMinMaxRadioLollipopDisabled = false;
      }
    },
    async onGenerateIFrameClick(){
      this.loadingExport = true;
      let elToExport = this.getElementToExport();
      let key = v4();
      key = `${key}.json`;
      let tool = this.selectedTab;
      let heightOffsetMediaMode = tool === 'radar' ? 0.9925 : 0.882;
      let heightOffset = tool === 'radar' ? 0.8 : 0.6935;
      let chartObject = {
        awsKey:key,
        tool: tool,
        category: 'player',
        componentId: this.playerId,
        width: elToExport.getAttribute("width"),
        height: this.mediaMode ? elToExport.getAttribute("width") * heightOffsetMediaMode : elToExport.getAttribute("width") * heightOffset
      }
      let postResponse = await UserChartService.postChart(chartObject)
      let chartEntity = postResponse.data;
      this.$refs.chartExportLinksModalRef.open(chartEntity);
      this.loadingExport = false;

      let urlResponse = await UserChartService.getUploadURL(chartEntity.id,key);
      let uploadUrl = urlResponse.data;
      var jsonse = JSON.stringify({
        size: Number(chartEntity.width),
        height: Number(chartEntity.height),
        margin: this.margin,
        radarData:this.radarData,
        polarData: this.polarData,
        darkMode: this.darkMode,
        dataPer90MinText: this.dataPer90MinText,
        adjustToPossessionText: this.adjustToPossessionText,
        playerName: this.player.name,
        radarTitle: this.radarTitle,
        minsPlayed: this.radarData.minutesPlayed,
        yob: this.yob,
        comparePlayerData: this.comparePlayerData,
        key: this.chartKey,
        mediaMode: this.mediaMode,
        colors: this.radarColors,
        bgColor: this.mediaMode ? this.mediaModeData.bgColor : this.defaultColors.bgColor,
        textColor: this.mediaModeData.textColor,
        axisColor: this.mediaModeData.axisColor,
        logoCfg: this.mediaModeData.logo,
        id:`${this.player.playerId}-${this.radarId}`,
        mediaModeData: this.mediaModeData,
        selectedTab: this.selectedTab,
        avatarSize: this.avatarSize,
        playerAvatarMediaKey: this.playerAvatarMediaKey,
        player:this.player,
        chartType: tool,
        top5leagues: this.minMaxModel,
        lollipopData: this.lollipopData,
        language: this.currentUserLanguage,
        team:this.team
      });
      var blob = new Blob([jsonse], {type: "application/json"});
      let uploadResponse = await DocumentService.upload(uploadUrl,blob);
      this.postSearchChart(chartEntity);
    },
    postSearchChart(chart){
      const authorized = true;
      let metaInfo = null;
      let category = "player";
      let urlId = this.playerId;

      metaInfo = JSON.stringify({
        link: `${API_URL}${chart.id}/key/${chart.awsKey}/compId/${chart.componentId}/catId/${chart.categoryId}/tId/${chart.toolId}`
      });
      const tool = 'embed';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);
    },
    onAutoCompleteSeasonChange(compoundId){
      if (this.seasonDataSelectedCheckBoxModel.length) {
        let object = _.find(this.playerSeasonData,(s) => compoundId.includes(s.compoundId)); //compoundId
        this.onSeasonChange(object);
      } else {
        this.seasonDataSelectedCheckBoxModel = [];
      }
    },
    onAutoCompleteCompareSeasonChange(compoundId){
      let object = _.find(this.comparePlayerSeasonData,(s) => s.compoundId === compoundId);
      this.onComparePlayerSeasonChange(object);
    },
    async onLeagueAverageChange(averageSeasonObject){
      if(averageSeasonObject){
        this.clearComparePlayerSection();
        //Clear Previous Performance radio buttons
        this.autoCompareModel = null;

        const seasonsSelected = this.playerSeasonData.filter((s) =>
          this.seasonIdsMainPlayerSelected.includes(s.seasonId) ||
          this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}`) || 
          this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}-${s.teamId}`)
        );

        //Get template object to get position name of template
        let positionOfTemplateActive = this.templateActive ? this.templateActive.position.toLowerCase() : "";
        let radarId = this.templateActive.radarId ? this.templateActive.radarId : 0;

        let metaInfo = JSON.stringify({
           playerId: this.playerId,
           playerName: this.player.name,
           compareSeasonId: averageSeasonObject.seasonId,
           compareSeasonName: averageSeasonObject.seasonName,
           templatePositionId: this.templateActive.positionId,
           isAverage: true
        });

        let response = await PlayerRadarService.getRadarData(
          this.playerId,
          [...new Set(seasonsSelected.map((s) => s.teamId))],//Remove duplicates teamIds
          [...new Set(seasonsSelected.map((s) => s.seasonId))],//Remove duplicates seasonIds
          [0],
          this.templateActive.positionId,
          //Mark top5Leagues as top 5 for back only when first radio selected
          this.minMaxModel === "top5Leagues",
          averageSeasonObject.seasonId,
          this.currentUser.clientId,
          radarId,
          //allPositions,
          true,
          this.selectedTab === "radar",
          this.allGamesModel,
          this.$route.path,
          Intl.DateTimeFormat().resolvedOptions().timeZone,
          navigator.userAgent,
          metaInfo
        );

        this.comparePlayerRadarData = response.data;

        let avgRadar = [...this.comparePlayerRadarData.statDTOs];

        avgRadar[0].forEach((stat, i) => {
          avgRadar[0][i].valueToShow = stat.avgValue;
          //Check if avgValue is between min and max
          avgRadar[0][i].value = this.getValueBetweenLimits(stat.avgValue, stat.minValue, stat.maxValue, stat.isReverse);
        });

        //Concat Radares
        let data = this.mainPlayerRadarData.statDTOs.concat(
          avgRadar
        );
        this.radarData = {statDTOs: data,
                          minutesPlayed: this.mainPlayerRadarData.minutesPlayed,
                          radarPosition: this.mainPlayerRadarData.radarPosition,
                          numberOfPlayers: this.mainPlayerRadarData.numberOfPlayers
                         };

        this.comparePlayerData = {
          playerName: this.$t("playerRecruitment.average") + " " + this.$t("positions." + positionOfTemplateActive),
          seasonsName: this.$t("playerRecruitment.average") + " " + averageSeasonObject.seasonName.replace(" 20", " '"),
          currentMatchDay: averageSeasonObject.currentMatchDay
        };

        this.updateChartsByRef();
        //Update comparisonFace to League crest
        this.mediaModeData.comparisonFace.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${averageSeasonObject.leagueId}.png`;
        this.mediaModeData.comparisonFace.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0.png`;

      }else{
        this.clearSearchItems();
      }
    },
    async onAutoCompareChange(){
      //Clear League Average select
      this.leaguesAverageObjectModel = null;
      //-1 means 'Last Season' radio selected
      if(this.autoCompareModel == -1){
        let player = _.find(this.dataSetAllPlayers.players,(p) => p.id === this.playerId);
        player.playerId = player.id;
        this.onResultClicked({value: player}, false);
      //Other cases, autoCompareModel contains number of games
      }else{
        this.clearComparePlayerSection();
        let games = this.autoCompareModel;
        let radarId = this.templateActive.radarId ? this.templateActive.radarId : 0;
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const browser = navigator.userAgent;
        const url = this.$route.path;

        const seasonsSelected = _.chain(this.playerSeasonData).filter(psd => psd.regular).map(psd => {
          psd.time = moment(psd.lastMatchDate,"DD/MM/YYYY").unix();
          return psd;
        }).orderBy("time","desc").first().value();

        let metaInfo = JSON.stringify({
           playerId: this.playerId,
           playerName: this.player.name,
           comparePlayerId: this.playerId,
           comparePlayerName: this.player.name,
           games: games,
           templatePositionId: this.templateActive.positionId
        });

        let minMaxSeasonToGet = seasonsSelected.seasonId
        if (this.minMaxModel === "ownSeason")
          minMaxSeasonToGet = this.currentUserSeasonId
        if (this.minMaxModel === 'champions')
          minMaxSeasonToGet = 8
        if (this.minMaxModel === 'europa')
          minMaxSeasonToGet = 9

        let radarResponse = await PlayerRadarService.getRadarDataByGames(
            this.playerId,
            seasonsSelected.seasonId,
            this.templateActive.positionId,
            //Mark top5Leagues as true for back only when first radio selected
            this.minMaxModel === "top5Leagues",
            minMaxSeasonToGet,
            this.currentUser.clientId,
            radarId,
            this.selectedTab === "radar",
            url,
            timeZone,
            browser,
            metaInfo,
            games);

        this.comparePlayerData = {
          playerName: this.player.name,
          teamName: this.player.teamName,
          seasonsName: `${this.$t("team.latestXGames",this.currentUserLanguage,{0: games})} - ${seasonsSelected.seasonName}`,
          yob: this.player.dob.split("/")[2].substring(2, 4),
          playerId: this.player.playerId,
          //If physical or arrigo radar, take just physical minutes played
          minsPlayed: (this.templateActive.cPD || this.templateActive.cA) ? 
                      radarResponse.data.minsPlayedPD : radarResponse.data.minutesPlayed
        };

        this.mediaModeData.comparisonUpperText = this.comparePlayerData.playerName;
        this.mediaModeData.comparisonLowerText = this.$t("playerDetail.performance");
        this.mediaModeData.comparisonFace.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.comparePlayerData.playerId}.png`;
        this.mediaModeData.comparisonFace.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0.png`;

        this.comparePlayerRadarData = radarResponse.data;

        //Concat Radares
        let data = this.mainPlayerRadarData.statDTOs.concat(
          radarResponse.data.statDTOs
        );
        this.radarData = {statDTOs: data,
                          minutesPlayed: this.mainPlayerRadarData.minutesPlayed,
                          radarPosition: this.mainPlayerRadarData.radarPosition,
                          numberOfPlayers: this.mainPlayerRadarData.numberOfPlayers
                         };

        this.updateChartsByRef();

      }
    },
    onShortPositionChange(pos){
      if (this.shortPositionsPlayedModel.length > 0) {
        this.renderRadar();
      } else {
        //Doesn't allow uncheck all checkbox of Short Positions. If selected short Position = 0, then check the short position again
        this.shortPositionsPlayedModel = [pos];
      }

      if(this.autoCompareModel != null){
        this.onAutoCompareChange();
      }
    },
    onCompareShortPositionChange(pos){
      if (this.shortPositionsPlayedComparePlayerModel.length > 0) {
        this.renderComparisonRadar();
      } else {
        //Doesn't allow uncheck all checkbox of Compare Player Short Positions. If selected short Position = 0, then check the short position again
        this.shortPositionsPlayedComparePlayerModel = [pos];
      }
    },
    hasMinimumGames(games){
        const seasonsSelected = this.playerSeasonData.filter((s) =>
          this.seasonIdsMainPlayerSelected.includes(s.seasonId) ||
          this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}`) || 
          this.seasonIdsMainPlayerSelected.includes(`${s.seasonId}-${s.teamId}`)
        );
        return _.some(seasonsSelected,(s) => s.gamesPlayed >= games);
    },
    getCategoryOrderByPosition(stats){
      //Don't need order for GoalKeepers (1) neither for WingBacks (7) on Polar
      if(this.positionIdOfTemplateActive === 1)
        return stats;

      return stats.map((d) => {
        //Order stats (see categories_order.js) just for Lollipop. Radar and Polar get order from field order of dim_radar_stat
        d.categoryOrder = CATEGORIES_ORDER[this.positionIdOfTemplateActive][d.categoryId];
        return d;
      });

    },
    getValueBetweenLimits(value, min, max, isReverse){
      if (isReverse)
        return value < max ? max : value > min ? min : value;
      else
        return value < min ? min : value > max ? max : value;
    },
    updateChartsByRef(force = false){
      if(this.$refs.radarRef){
        this.$refs.radarRef.drawRadarChart(`#radar${this.player.playerId}-${this.radarId}`, this.radarData, this.comparePlayerData, this.size, this.margin);
      }
      if(this.$refs.lollipopRef){
        this.$refs.lollipopRef.drawChart(`#lollipop${this.player.playerId}-${this.radarId}`, this.lollipopData);
      }
      if(this.$refs.compareLollipopRef){
        this.$refs.compareLollipopRef.drawChart(`#lollipop${this.player.playerId}-${this.radarId}`, this.lollipopData);
      }
      if(this.$refs.playerAvatarMediaRef){
        this.$refs.playerAvatarMediaRef.printD3(force)
      }
      if(this.$refs.driblabSocialMediaRef){
        this.$refs.driblabSocialMediaRef.printD3(force)
      }
      if(this.mediaMode || this.selectedTab === "polar"){
        //reload all components to take effect of media properties
        this.playerAvatarMediaKey++;
        this.socialMediaKey++;
        this.chartKey++;
      }
    },
    getPositionCode(position) {
      return getPositionCode(this.currentUser.fieldPositionCodeId, position);
    },
    onRadarGamesChange(){
      this.loading = true;
      this.renderRadar();
      if (this.comparePlayerData) {
        this.renderComparisonRadar();
      }
    },
    onNewTemplateClick(){
      this.$refs.formModalRef.open();
    },
    getRadarTemplateSubtitle(groupKey) {
      return getRadarTemplateSubtitle(groupKey, this.currentUserLanguage);
    },
    getRadioStyle(template) {
      const isDisabled = (this.physicalRadarDisabled && template.cPD) || (this.arrigoRadarDisabled && template.cA);
      return getRadioStyle(template, isDisabled);
    }
  },
  beforeDestroy(){
    this.dataSetFiltered = [];
    setTimeout(() => {
      this.dataSetAllPlayers = [];
      this.$forceUpdate();
    },1)
  },
  destroyed(){
    window.removeEventListener("resize", this.onWindowResize);
    this.radarData = null;
    this.dataSetFiltered = [];
    this.dataSetAllPlayers = [];
    this._props = null;
    this._watcher = null;
    this._watchers = null;
    this.$options.propsData = null;
    this.$parent = null;
    this._self = null;
    this.$children = null;
    this.$refs = null;
    this._refs = null;
  }
};
</script>
<style lang="scss">
  .big-avatar-skeleton{
    .v-skeleton-loader__avatar{
      width: 320px;
      height: 320px;
    }
  }

  /* Axis dark mode for Lollipop and Compare Lollipop charts*/
  .axisDark text{
    font-family: "NeueMontreal" !important;
  }

  .custom-radio:not(.v-item--active) .v-icon {
    color: var(--unselected-radio-color) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/player/PlayerRadar.vue